import * as React from 'react'
import PropTypes from 'prop-types'

import styled from '@emotion/styled'

export const SvgIcon = styled.svg`
  margin-top: -0.105em;
  margin-bottom: -0.145em;
  height: 1.25em;
  width: 1.25em;
  vertical-align: -0.185em;
`

export function Add() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
    </SvgIcon>
  )
}

export function ArrowRightAlt() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path fill="currentColor" d="M16.01 11H4v2h12.01v3L20 12l-3.99-4z" />
    </SvgIcon>
  )
}

export function BankNote() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path fill="currentColor" d="M2,5v14h20V5H2z M9,17l-5-5V7h11l5,5v5H9z" />
      <circle fill="currentColor" cx="12" cy="12" r="3" />
    </SvgIcon>
  )
}

export function BankNotePlayboomDisabled() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.01197 16.3848C2.16412 16.3848 1.44069 15.7349 1.24696 14.8788C1.03852 13.9577 0.833252 13.0029 0.833252 10.5001C0.833252 7.99726 1.03852 7.04245 1.24696 6.12133C1.44069 5.26522 2.16412 4.61536 3.01197 4.61536H16.9883C17.8362 4.61536 18.5602 5.26522 18.7606 6.11969C18.9665 6.99774 19.167 7.92659 19.167 10.5001C19.167 13.0735 18.9665 14.0024 18.7606 14.8804C18.5602 15.7349 17.8362 16.3848 16.9883 16.3848H3.01197ZM4.24538 6.48652C3.41702 6.49716 2.75413 7.1773 2.76477 8.00566C2.77542 8.83402 3.45556 9.49691 4.28392 9.48627L5.15333 9.4751C5.98169 9.46446 6.64458 8.78431 6.63394 7.95595C6.62329 7.12759 5.94315 6.4647 5.11479 6.47535L4.24538 6.48652ZM10 12.643C11.1835 12.643 12.1429 11.6836 12.1429 10.5001C12.1429 9.31663 11.1835 8.35724 10 8.35724C8.81657 8.35724 7.85718 9.31663 7.85718 10.5001C7.85718 11.6836 8.81657 12.643 10 12.643ZM13.5236 13.0057C13.5129 12.1773 14.1758 11.4972 15.0042 11.4865L15.8736 11.4753C16.7019 11.4647 17.3821 12.1276 17.3927 12.956C17.4034 13.7843 16.7405 14.4645 15.9121 14.4751L15.0427 14.4863C14.2144 14.4969 13.5342 13.834 13.5236 13.0057Z"
        fill="white"
      />
    </SvgIcon>
  )
}

export function BankNotePlayboomDefault() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.47441 14.612C1.66311 15.4159 2.36773 16.0262 3.19353 16.0262H16.8065C17.6323 16.0262 18.3376 15.4159 18.5328 14.6135C18.7333 13.789 18.9286 12.9167 18.9286 10.5C18.9286 8.08333 18.7333 7.21107 18.5328 6.38651C18.3376 5.5841 17.6323 4.97383 16.8065 4.97383L3.19354 4.97383C2.36773 4.97383 1.66311 5.5841 1.47441 6.38806C1.27139 7.25306 1.07146 8.1497 1.07146 10.5C1.07146 12.8503 1.27139 13.747 1.47441 14.612Z"
        fill="#716377"
        stroke="#9E8FA3"
        strokeWidth="1.5"
      />
      <ellipse cx="10" cy="10.5001" rx="2.14286" ry="2.14286" fill="#9E8FA3" />
      <path
        d="M4.26454 7.9864L5.13395 7.97523"
        stroke="#9E8FA3"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0235 12.9864L15.8929 12.9752"
        stroke="#9E8FA3"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}

export function BankNotePlayboomActive() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.20465 6.55948C2.32141 6.062 2.74832 5.72388 3.19361 5.72388L16.8066 5.72388C17.2517 5.72388 17.6822 6.06253 17.8041 6.56381C17.9902 7.3291 18.1787 8.1418 18.1787 10.5001C18.1787 12.8583 17.9902 13.671 17.8041 14.4363C17.6822 14.9376 17.2517 15.2762 16.8066 15.2762H3.19361C2.74832 15.2762 2.32141 14.9381 2.20465 14.4406C2.01375 13.6273 1.82153 12.7882 1.82153 10.5001C1.82153 8.21191 2.01375 7.37283 2.20465 6.55948ZM3.19361 4.22388C1.98729 4.22388 1.00496 5.10629 0.744331 6.21673C0.529189 7.13338 0.321533 8.08757 0.321533 10.5001C0.321533 12.9125 0.529189 13.8667 0.744331 14.7834C1.00496 15.8938 1.98729 16.7762 3.19361 16.7762H16.8066C18.0131 16.7762 18.9932 15.8944 19.2616 14.7908C19.4766 13.907 19.6787 12.9752 19.6787 10.5001C19.6787 8.02496 19.4766 7.09314 19.2616 6.20931C18.9932 5.10576 18.0131 4.22388 16.8066 4.22388H3.19361ZM10 12.643C11.1835 12.643 12.1429 11.6836 12.1429 10.5002C12.1429 9.31669 11.1835 8.3573 10 8.3573C8.81657 8.3573 7.85718 9.31669 7.85718 10.5002C7.85718 11.6836 8.81657 12.643 10 12.643ZM2.76463 8.00561C2.75399 7.17725 3.41688 6.49711 4.24524 6.48647L5.11465 6.4753C5.94301 6.46465 6.62315 7.12754 6.63379 7.9559C6.64444 8.78426 5.98155 9.46441 5.15319 9.47505L4.28378 9.48622C3.45542 9.49686 2.77527 8.83397 2.76463 8.00561ZM15.0043 11.4865C14.1759 11.4971 13.513 12.1773 13.5237 13.0056C13.5343 13.834 14.2145 14.4969 15.0428 14.4862L15.9122 14.475C16.7406 14.4644 17.4035 13.7843 17.3928 12.9559C17.3822 12.1275 16.702 11.4647 15.8737 11.4753L15.0043 11.4865Z"
        fill="url(#paint0_linear_113_1076)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_113_1076"
          x1="1.27756"
          y1="5.91272"
          x2="11.2383"
          y2="22.4352"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.29" stopColor="#FFA267" />
          <stop offset="0.48" stopColor="#FF7154" />
        </linearGradient>
      </defs>
    </SvgIcon>
  )
}

export function BankNotePlayboom() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.47441 14.612C1.66311 15.4159 2.36773 16.0262 3.19353 16.0262H16.8065C17.6323 16.0262 18.3376 15.4159 18.5328 14.6135C18.7333 13.789 18.9286 12.9167 18.9286 10.5C18.9286 8.08333 18.7333 7.21107 18.5328 6.38651C18.3376 5.5841 17.6323 4.97383 16.8065 4.97383L3.19354 4.97383C2.36773 4.97383 1.66311 5.5841 1.47441 6.38806C1.27139 7.25306 1.07146 8.1497 1.07146 10.5C1.07146 12.8503 1.27139 13.747 1.47441 14.612Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <ellipse
        cx="10"
        cy="10.5001"
        rx="2.14286"
        ry="2.14286"
        fill="currentColor"
      />
      <path
        d="M4.26454 7.9864L5.13395 7.97523"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0235 12.9864L15.8929 12.9752"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}

export function BankNoteWettenlive() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.125 14.375H1.875V15.625H18.125V14.375Z"
        fill="currentColor"
      />
      <path d="M16.875 16.25H3.125V17.5H16.875V16.25Z" fill="currentColor" />
      <path
        d="M18.75 6.875C17.7558 6.87386 16.8026 6.47841 16.0996 5.77539C15.3966 5.07238 15.0011 4.11921 15 3.125V2.5H5V3.125C4.99886 4.11921 4.60341 5.07238 3.90039 5.77539C3.19738 6.47841 2.24421 6.87386 1.25 6.875H0.625V9.375H1.25C2.24421 9.37614 3.19738 9.77159 3.90039 10.4746C4.60341 11.1776 4.99886 12.1308 5 13.125V13.75H15V13.125C15.0011 12.1308 15.3966 11.1776 16.0996 10.4746C16.8026 9.77159 17.7558 9.37614 18.75 9.375H19.375V6.875H18.75ZM10 11.875C9.25832 11.875 8.5333 11.6551 7.91661 11.243C7.29993 10.831 6.81928 10.2453 6.53545 9.56006C6.25162 8.87484 6.17736 8.12084 6.32206 7.39341C6.46675 6.66598 6.8239 5.9978 7.34835 5.47335C7.8728 4.9489 8.54098 4.59175 9.26841 4.44706C9.99584 4.30236 10.7498 4.37662 11.4351 4.66045C12.1203 4.94428 12.706 5.42493 13.118 6.04161C13.5301 6.6583 13.75 7.38332 13.75 8.125C13.7489 9.11921 13.3534 10.0724 12.6504 10.7754C11.9474 11.4784 10.9942 11.8739 10 11.875Z"
        fill="currentColor"
      />
      <path
        d="M3.75 3.125V2.5H0.625V5.625H1.25C1.91282 5.62428 2.54828 5.36065 3.01697 4.89197C3.48565 4.42328 3.74928 3.78782 3.75 3.125Z"
        fill="currentColor"
      />
      <path
        d="M1.25 10.625H0.625V13.75H3.75V13.125C3.74928 12.4622 3.48565 11.8267 3.01697 11.358C2.54828 10.8893 1.91282 10.6257 1.25 10.625Z"
        fill="currentColor"
      />
      <path
        d="M18.75 5.625H19.375V2.5H16.25V3.125C16.2507 3.78782 16.5143 4.42328 16.983 4.89197C17.4517 5.36065 18.0872 5.62428 18.75 5.625Z"
        fill="currentColor"
      />
      <path
        d="M16.25 13.125V13.75H19.375V10.625H18.75C18.0872 10.6257 17.4517 10.8893 16.983 11.358C16.5143 11.8267 16.2507 12.4622 16.25 13.125Z"
        fill="currentColor"
      />
      <path
        d="M10 10.625C11.3807 10.625 12.5 9.50571 12.5 8.125C12.5 6.74429 11.3807 5.625 10 5.625C8.61929 5.625 7.5 6.74429 7.5 8.125C7.5 9.50571 8.61929 10.625 10 10.625Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function BankNoteCasinosky() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.875 0.75H18.125C18.8153 0.75 19.375 1.30964 19.375 2V12C19.375 12.6903 18.8153 13.25 18.125 13.25H1.875C1.18464 13.25 0.625 12.6903 0.625 12V2C0.625 1.30964 1.18464 0.75 1.875 0.75ZM12.5 7C12.5 8.38075 11.3807 9.5 10 9.5C8.61925 9.5 7.5 8.38075 7.5 7C7.5 5.61925 8.61925 4.5 10 4.5C11.3807 4.5 12.5 5.61925 12.5 7ZM2.43018 3.55342C2.43018 2.96662 2.90587 2.49092 3.49268 2.49092C4.07948 2.49092 4.55518 2.96662 4.55518 3.55342C4.55518 4.14023 4.07948 4.61592 3.49268 4.61592C2.90587 4.61592 2.43018 4.14023 2.43018 3.55342ZM16.5288 9.42696C15.942 9.42696 15.4663 9.90266 15.4663 10.4895C15.4663 11.0763 15.942 11.552 16.5288 11.552C17.1156 11.552 17.5913 11.0763 17.5913 10.4895C17.5913 9.90266 17.1156 9.42696 16.5288 9.42696Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function CoinStack() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M4.086,5C4.562,4.595,6.216,4,8,4s3.438,0.595,3.914,1H14c0-2.243-4.121-3-6-3S2,2.757,2,5v12c0,2.245,4.121,3,6,3c0.287,0,0.631-0.021,1-0.058v-2.009C8.675,17.974,8.342,18,8,18c-1.916,0-3.682-0.684-4-1.086v-0.693C5.32,16.776,6.985,17,8,17c0.288,0,0.631-0.021,1-0.058v-2.009C8.675,14.974,8.342,15,8,15c-1.937,0-3.709-0.697-4-1.098v-0.682C5.32,13.776,6.985,14,8,14c0.288,0,0.631-0.021,1-0.058v-2.009C8.675,11.974,8.342,12,8,12c-1.937,0-3.709-0.697-4-1.098v-0.682C5.32,10.776,6.985,11,8,11c0.288,0,0.631-0.021,1-0.058V8.934C8.675,8.974,8.342,9,8,9C6.063,9,4.291,8.303,4,7.902V7.221C5.32,7.776,6.985,8,8,8c0.288,0,0.631-0.021,1-0.058V5.935C8.675,5.974,8.342,6,8,6C6.216,6,4.562,5.407,4.086,5z"
      />
      <path
        fill="currentColor"
        d="M16,7c-1.879,0-6,0.757-6,3v9c0,2.245,4.121,3,6,3s6-0.755,6-3v-9C22,7.757,17.879,7,16,7z M20,12.902C19.709,13.303,17.937,14,16,14s-3.709-0.697-4-1.098v-0.682C13.32,12.776,14.985,13,16,13s2.68-0.224,4-0.779V12.902z M20,15.902C19.709,16.303,17.937,17,16,17s-3.709-0.697-4-1.098v-0.682C13.32,15.776,14.985,16,16,16s2.68-0.224,4-0.779V15.902z M16,9c1.784,0,3.438,0.595,3.914,1c-0.476,0.407-2.13,1-3.914,1s-3.438-0.593-3.914-1C12.562,9.595,14.216,9,16,9z M16,20c-1.916,0-3.682-0.684-4-1.086v-0.693C13.32,18.776,14.985,19,16,19s2.68-0.224,4-0.779v0.693C19.682,19.316,17.916,20,16,20z"
      />
    </SvgIcon>
  )
}

export function CoinStackPlayboom() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5642 4.20973C1.48757 5.22733 1.42857 6.58297 1.42857 7.64027C1.42857 8.88017 1.5097 10.0962 1.60528 11.2803C1.7328 12.8602 2.95684 14.1887 4.52848 14.3941C4.66319 14.4117 4.79839 14.4284 4.93408 14.4439"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.52849 10.7897C2.89206 10.6638 1.57675 9.67131 1.42857 8.46365"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M4.81163 6.84704C2.69444 6.55942 1.53317 5.72448 1.53317 4.44361C1.53317 2.834 3.36703 1.92859 6.62723 1.92859C9.10939 1.92859 10.7648 2.45342 11.4135 3.41428"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3446 8.73125C18.4328 9.84916 18.5046 10.9949 18.5046 12.1618C18.5046 13.4017 18.4235 14.6177 18.3279 15.8018C18.2004 17.3817 16.9764 18.7102 15.4048 18.9156C14.7173 19.0055 14.0168 19.0714 13.3059 19.0714C12.5951 19.0714 11.8946 19.0055 11.2071 18.9156C9.63549 18.7102 8.41148 17.3817 8.28396 15.8018C8.18838 14.6177 8.10725 13.4017 8.10725 12.1618C8.10725 11.1045 8.16625 9.74884 8.24288 8.73125"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M18.5046 12.9851C18.3565 14.1928 17.0411 15.1853 15.4047 15.3111C14.717 15.364 14.0165 15.4024 13.3059 15.4024C12.5954 15.4024 11.8949 15.364 11.2072 15.3111C9.57074 15.1853 8.25543 14.1928 8.10725 12.9851"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M13.3059 11.4801C16.5661 11.4801 18.4 10.5747 18.4 8.96513C18.4 7.35551 16.5661 6.4501 13.3059 6.4501C10.0457 6.4501 8.21185 7.35551 8.21185 8.96513C8.21185 10.5747 10.0457 11.4801 13.3059 11.4801Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}

export function CoinStackWettenlive() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.85545 4.06249H16.875V2.01249C16.875 1.92001 16.8545 1.82868 16.8149 1.74508C16.7753 1.66149 16.7177 1.58772 16.6462 1.52909C16.5747 1.47046 16.491 1.42844 16.4013 1.40604C16.3116 1.38365 16.218 1.38145 16.1273 1.3996L1.75232 3.7621C1.64528 3.78341 1.54569 3.83237 1.46345 3.90413C1.38121 3.97588 1.31919 4.06792 1.28357 4.17108C1.46563 4.0991 1.65968 4.06226 1.85545 4.06249Z"
        fill="currentColor"
      />
      <path
        d="M18.1055 5H1.85545C1.68969 5 1.53072 5.06585 1.41351 5.18306C1.2963 5.30027 1.23045 5.45924 1.23045 5.625V16.875C1.23045 17.0408 1.2963 17.1997 1.41351 17.3169C1.53072 17.4342 1.68969 17.5 1.85545 17.5H18.1055C18.2712 17.5 18.4302 17.4342 18.5474 17.3169C18.6646 17.1997 18.7305 17.0408 18.7305 16.875V5.625C18.7305 5.45924 18.6646 5.30027 18.5474 5.18306C18.4302 5.06585 18.2712 5 18.1055 5ZM14.375 12.5C14.1278 12.5 13.8861 12.4267 13.6805 12.2893C13.475 12.152 13.3147 11.9568 13.2201 11.7284C13.1255 11.4999 13.1008 11.2486 13.149 11.0061C13.1972 10.7637 13.3163 10.5409 13.4911 10.3661C13.6659 10.1913 13.8886 10.0722 14.1311 10.024C14.3736 9.97579 14.6249 10.0005 14.8533 10.0951C15.0817 10.1898 15.277 10.35 15.4143 10.5555C15.5517 10.7611 15.625 11.0028 15.625 11.25C15.625 11.5815 15.4933 11.8995 15.2589 12.1339C15.0244 12.3683 14.7065 12.5 14.375 12.5Z"
        fill="currentColor"
      />
      <path
        d="M1.22382 10.1367V4.53125C1.22382 4.04961 1.44725 3.80938 1.82616 3.75C3.20116 3.53398 6.06757 3.41797 6.06757 3.41797C6.06757 3.41797 5.74218 4.04297 4.99999 4.04297V5C5.72264 5 6.22382 5.91797 6.22382 5.91797L3.31366 9.21875L1.22382 10.1367Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function CoinStackCasinosky() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_832_3418)">
        <path
          d="M9.59876 15.7243C9.77103 15.8235 9.96499 15.9172 10.1794 16.0042C11.1653 16.4042 12.5025 16.629 13.8968 16.629C15.2911 16.629 16.6283 16.4042 17.6143 16.0042C17.8287 15.9172 18.0226 15.8235 18.1949 15.7243C18.8149 16.0814 19.1541 16.5099 19.1541 16.9526C19.1541 17.5184 18.6002 18.0609 17.6143 18.461C16.6283 18.861 15.2911 19.0857 13.8968 19.0857C12.5025 19.0857 11.1653 18.861 10.1794 18.461C9.19344 18.0609 8.63955 17.5184 8.63955 16.9526C8.63955 16.5099 8.97875 16.0814 9.59876 15.7243Z"
          fill="currentColor"
        />
        <path
          d="M7.74207 12.6023C7.2179 12.672 6.6652 12.7086 6.10322 12.7086C4.70891 12.7086 3.3717 12.4838 2.38577 12.0838C2.17139 11.9968 1.97744 11.9031 1.80516 11.8039C1.18515 12.161 0.845947 12.5895 0.845947 13.0322C0.845947 13.598 1.39984 14.1405 2.38577 14.5406C3.3717 14.9406 4.70891 15.1653 6.10322 15.1653C6.6652 15.1653 7.2179 15.1288 7.74207 15.059V12.6023Z"
          fill="currentColor"
        />
        <path
          d="M7.74207 9.2408C7.2179 9.31058 6.6652 9.34709 6.10322 9.34709C4.70891 9.34709 3.3717 9.12236 2.38577 8.72233C2.17139 8.63534 1.97744 8.54162 1.80516 8.44239C1.18515 8.79953 0.845947 9.22806 0.845947 9.67077C0.845947 10.2365 1.39984 10.7791 2.38577 11.1791C3.3717 11.5791 4.70891 11.8039 6.10322 11.8039C6.6652 11.8039 7.2179 11.7673 7.74207 11.6976V9.2408Z"
          fill="currentColor"
        />
        <path
          d="M9.59876 12.3628C9.77103 12.462 9.96499 12.5557 10.1794 12.6427C11.1653 13.0428 12.5025 13.2675 13.8968 13.2675C15.2911 13.2675 16.6283 13.0428 17.6143 12.6427C17.8287 12.5557 18.0226 12.462 18.1949 12.3628C18.8149 12.7199 19.1541 13.1485 19.1541 13.5912C19.1541 14.1569 18.6002 14.6995 17.6143 15.0995C16.6283 15.4995 15.2911 15.7243 13.8968 15.7243C12.5025 15.7243 11.1653 15.4995 10.1794 15.0995C9.19344 14.6995 8.63955 14.1569 8.63955 13.5912C8.63955 13.1485 8.97875 12.7199 9.59876 12.3628Z"
          fill="currentColor"
        />
        <path
          d="M1.80516 5.31392C1.97744 5.41315 2.17139 5.50687 2.38577 5.59385C3.3717 5.99388 4.70891 6.21862 6.10322 6.21862C7.49754 6.21862 8.83475 5.99388 9.82068 5.59385C10.0351 5.50687 10.229 5.41315 10.4013 5.31392C11.0213 5.67106 11.3605 6.09958 11.3605 6.5423C11.3605 7.10803 10.8066 7.65059 9.82068 8.05062C8.83475 8.45065 7.49754 8.67538 6.10322 8.67538C4.70891 8.67538 3.3717 8.45065 2.38577 8.05062C1.39984 7.65059 0.845947 7.10803 0.845947 6.5423C0.845947 6.09958 1.18515 5.67106 1.80516 5.31392Z"
          fill="currentColor"
        />
        <path
          d="M8.63955 10.1187C8.63955 10.7191 9.19344 11.295 10.1794 11.7196C11.1653 12.1442 12.5025 12.3827 13.8968 12.3827C15.2911 12.3827 16.6283 12.1442 17.6143 11.7196C18.6002 11.295 19.1541 10.7191 19.1541 10.1187C19.1541 9.51825 18.6002 8.94239 17.6143 8.51781C16.6283 8.09323 15.2911 7.8547 13.8968 7.8547C12.5025 7.8547 11.1653 8.09323 10.1794 8.51781C9.19344 8.94239 8.63955 9.51825 8.63955 10.1187Z"
          fill="currentColor"
        />
        <path
          d="M0.845947 3.17828C0.845947 3.77872 1.39984 4.35458 2.38577 4.77916C3.3717 5.20374 4.70891 5.44227 6.10322 5.44227C7.49754 5.44227 8.83475 5.20374 9.82068 4.77916C10.8066 4.35458 11.3605 3.77872 11.3605 3.17828C11.3605 2.57783 10.8066 2.00197 9.82068 1.57739C8.83475 1.15281 7.49754 0.914284 6.10322 0.914284C4.70891 0.914284 3.3717 1.15281 2.38577 1.57739C1.39984 2.00197 0.845947 2.57783 0.845947 3.17828Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_832_3418">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}

export function Chat() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"
      />
    </SvgIcon>
  )
}

export function Check() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5752 4.64746C16.9823 5.02066 17.0098 5.65322 16.6367 6.06034L8.87889 14.5234C8.69458 14.7244 8.43615 14.8415 8.16346 14.8474C7.89077 14.8533 7.62749 14.7476 7.43463 14.5547L3.90837 11.0285C3.51785 10.638 3.51785 10.0048 3.90837 9.61427C4.2989 9.22375 4.93206 9.22375 5.32259 9.61427L8.11032 12.402L15.1623 4.70889C15.5355 4.30178 16.1681 4.27427 16.5752 4.64746Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function CheckBold() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </SvgIcon>
  )
}

export function CheckCircle() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
      />
    </SvgIcon>
  )
}

export function Clear() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
      />
    </SvgIcon>
  )
}

export function Edit() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
      />
    </SvgIcon>
  )
}

export function Email() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
      />
      <path d="M0 0h24v24H0z" fill="none" />
    </SvgIcon>
  )
}

export function Error() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
      />
    </SvgIcon>
  )
}

export function Visibility() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
      />
    </SvgIcon>
  )
}

export function VisibilityOff() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
      />
    </SvgIcon>
  )
}

export function Face() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z"
      />
    </SvgIcon>
  )
}

export function FaceWettenlive() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 1.875C5.51992 1.875 1.875 5.51992 1.875 10C1.875 14.4801 5.51992 18.125 10 18.125C14.4801 18.125 18.125 14.4801 18.125 10C18.125 5.51992 14.4801 1.875 10 1.875ZM10.0781 5.625C10.6344 5.625 11.1782 5.78995 11.6407 6.09899C12.1032 6.40803 12.4637 6.84729 12.6765 7.3612C12.8894 7.87512 12.9451 8.44062 12.8366 8.98619C12.7281 9.53176 12.4602 10.0329 12.0669 10.4262C11.6735 10.8196 11.1724 11.0874 10.6268 11.196C10.0812 11.3045 9.51575 11.2488 9.00183 11.0359C8.48791 10.823 8.04866 10.4626 7.73962 10C7.43058 9.53753 7.26562 8.99376 7.26562 8.4375C7.26562 7.69158 7.56194 6.97621 8.08939 6.44876C8.61683 5.92132 9.3322 5.625 10.0781 5.625ZM10 16.875C9.05174 16.8754 8.11371 16.6791 7.24516 16.2986C6.37661 15.918 5.59643 15.3615 4.95391 14.6641C5.29922 12.8758 8.40078 12.5 10 12.5C11.5992 12.5 14.7008 12.8758 15.0461 14.6637C14.4036 15.3612 13.6235 15.9179 12.7549 16.2985C11.8864 16.6791 10.9483 16.8754 10 16.875Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function FaceCasinosky() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_832_3412)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 10C20 12.6812 18.9447 15.116 17.227 16.9117C15.4127 18.8081 12.8596 19.9917 10.0298 20H10H9.97016C7.14043 19.9917 4.58723 18.8081 2.77304 16.9117C1.05523 15.116 0 12.6812 0 10C0 4.47716 4.47716 0 10 0C15.5229 0 20 4.47716 20 10ZM16.0611 15C14.6201 13.255 12.4399 12.1428 10 12.1428C7.56009 12.1428 5.37991 13.255 3.93879 15C5.37991 16.745 7.56009 17.8571 10 17.8571C12.4399 17.8571 14.6201 16.745 16.0611 15ZM10.0002 10.7142C11.9726 10.7142 13.5716 9.11526 13.5716 7.14281C13.5716 5.17037 11.9726 3.57139 10.0002 3.57139C8.02773 3.57139 6.42874 5.17037 6.42874 7.14281C6.42874 9.11526 8.02773 10.7142 10.0002 10.7142Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_832_3412">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}

export function FacePlayboomDisabled() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 10.5C12.4656 10.5 14.4643 8.5013 14.4643 6.03574C14.4643 3.57019 12.4656 1.57146 10 1.57146C7.53445 1.57146 5.53572 3.57019 5.53572 6.03574C5.53572 8.5013 7.53445 10.5 10 10.5Z"
        fill="white"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9259 15.634C19.8401 16.9123 18.6396 19.4287 16.3378 19.4287H3.66219C1.36044 19.4287 0.159946 16.9123 2.07408 15.634C4.34215 14.1192 7.06795 13.2361 10 13.2361C12.9321 13.2361 15.6579 14.1192 17.9259 15.634Z"
        fill="white"
        stroke="white"
        strokeWidth="1.5"
      />
    </SvgIcon>
  )
}

export function FacePlayboomDefault() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 10.5C12.4656 10.5 14.4643 8.5013 14.4643 6.03574C14.4643 3.57019 12.4656 1.57146 10 1.57146C7.53445 1.57146 5.53572 3.57019 5.53572 6.03574C5.53572 8.5013 7.53445 10.5 10 10.5Z"
        fill="#716377"
        stroke="#9E8FA3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9259 15.634C19.8401 16.9123 18.6396 19.4287 16.3378 19.4287H3.66219C1.36044 19.4287 0.159946 16.9123 2.07408 15.634C4.34215 14.1192 7.06795 13.2361 10 13.2361C12.9321 13.2361 15.6579 14.1192 17.9259 15.634Z"
        fill="#716377"
        stroke="#9E8FA3"
        strokeWidth="1.5"
      />
    </SvgIcon>
  )
}

export function FacePlayboomActive() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.28566 6.0357C6.28566 3.98435 7.9486 2.32141 9.99994 2.32141C12.0513 2.32141 13.7142 3.98435 13.7142 6.0357C13.7142 8.08704 12.0513 9.74998 9.99994 9.74998C7.9486 9.74998 6.28566 8.08704 6.28566 6.0357ZM9.99994 0.821411C7.12017 0.821411 4.78566 3.15593 4.78566 6.0357C4.78566 8.91547 7.12017 11.25 9.99994 11.25C12.8797 11.25 15.2142 8.91547 15.2142 6.0357C15.2142 3.15593 12.8797 0.821411 9.99994 0.821411ZM2.49051 16.2577C4.63912 14.8228 7.22068 13.9862 9.99991 13.9862C12.7791 13.9862 15.3607 14.8228 17.5093 16.2577C17.8587 16.4911 18.0229 16.7488 18.0886 16.9753C18.1556 17.2059 18.1366 17.459 18.0267 17.7076C17.8055 18.2083 17.2102 18.6787 16.3377 18.6787H3.66209C2.78966 18.6787 2.19432 18.2083 1.97309 17.7076C1.86324 17.459 1.84425 17.2059 1.91118 16.9753C1.97694 16.7488 2.14109 16.4911 2.49051 16.2577ZM9.99991 12.4862C6.91502 12.4862 4.04499 13.4158 1.65744 15.0103C1.0498 15.4161 0.646218 15.9523 0.470647 16.5572C0.29625 17.158 0.362344 17.7736 0.601063 18.3139C1.07698 19.391 2.23277 20.1787 3.66209 20.1787H16.3377C17.767 20.1787 18.9228 19.391 19.3988 18.3139C19.6375 17.7736 19.7036 17.158 19.5292 16.5572C19.3536 15.9523 18.95 15.4161 18.3424 15.0103C15.9548 13.4158 13.0848 12.4862 9.99991 12.4862Z"
        fill="url(#paint0_linear_113_1198)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_113_1198"
          x1="1.32328"
          y1="3.42581"
          x2="18.6537"
          y2="21.9688"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.29" stopColor="#FFA267" />
          <stop offset="0.48" stopColor="#FF7154" />
        </linearGradient>
      </defs>
    </SvgIcon>
  )
}

export function Home() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path fill="currentColor" d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
    </SvgIcon>
  )
}

export function Menu() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
      />
    </SvgIcon>
  )
}

export function Lightning() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 14 22"
    >
      <path
        fill="currentColor"
        d="M3.76636 21.1778L5.17551 13.8991L0.164551 11.7636L9.0043 1.15694L10.1103 0.822235L8.77146 7.8947L13.8357 10.0048L4.6778 20.921L3.76636 21.1778Z"
      />
    </SvgIcon>
  )
}

export function Lock() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
      />
    </SvgIcon>
  )
}

export function Loyalty() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7zm11.77 8.27L13 19.54l-4.27-4.27C8.28 14.81 8 14.19 8 13.5c0-1.38 1.12-2.5 2.5-2.5.69 0 1.32.28 1.77.74l.73.72.73-.73c.45-.45 1.08-.73 1.77-.73 1.38 0 2.5 1.12 2.5 2.5 0 .69-.28 1.32-.73 1.77z"
      />
    </SvgIcon>
  )
}

export function LoyaltyColored() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <defs>
        <linearGradient
          id="gradient"
          x1="6.518%"
          x2="116.948%"
          y1="106.321%"
          y2="0%"
        >
          <stop offset="0%" stopColor="#FFD87A" />
          <stop offset="100%" stopColor="#B532AB" />
        </linearGradient>
      </defs>
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="url(#gradient)"
        d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7zm11.77 8.27L13 19.54l-4.27-4.27C8.28 14.81 8 14.19 8 13.5c0-1.38 1.12-2.5 2.5-2.5.69 0 1.32.28 1.77.74l.73.72.73-.73c.45-.45 1.08-.73 1.77-.73 1.38 0 2.5 1.12 2.5 2.5 0 .69-.28 1.32-.73 1.77z"
      />
    </SvgIcon>
  )
}

export function LoyaltyPlayboom() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8161 19.8531C13.1552 18.8049 14.7107 17.8291 16.0214 16.5185C17.3321 15.2078 18.3078 13.6523 19.3561 12.3131C16.1581 8.65297 12.8774 5.37232 9.21725 2.17429C9.21725 2.17429 2.95784 0.8335 1.64715 2.14419C0.336456 3.45488 1.67725 9.7143 1.67725 9.7143C4.87527 13.3745 8.15593 16.6551 11.8161 19.8531Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <circle
        cx="5.99361"
        cy="6.5788"
        r="1.34551"
        transform="rotate(-45 5.99361 6.5788)"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1584 12.8853C12.779 12.2646 13.7853 12.2646 14.406 12.8853C14.979 13.4582 15.0401 14.3908 14.4909 15.0212C13.8345 15.7746 13.3141 16.2651 12.6061 16.8412C12.2484 17.1323 11.7355 17.1342 11.3757 16.8454C10.5822 16.2089 10.0565 15.7019 9.47246 15.0189C8.92998 14.3845 9.00112 13.4582 9.56928 12.8901C10.1926 12.2668 11.2032 12.2668 11.8265 12.8901L11.99 13.0536M11.99 13.0536L12.1584 12.8853L11.99 13.0536ZM11.99 13.0536L11.8265 12.8901L11.99 13.0536Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function Phone() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
      />
    </SvgIcon>
  )
}

export function Remove() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path fill="currentColor" d="M19 13H5v-2h14v2z" />
    </SvgIcon>
  )
}

export function Room() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
      />
    </SvgIcon>
  )
}

export function Search() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
      />
    </SvgIcon>
  )
}

export function Videocam() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"
      />
    </SvgIcon>
  )
}

export function VideocamWettenlive() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_139_241)">
        <path
          d="M14.1667 7.66667L18.5108 4.625C18.5733 4.58122 18.6466 4.55542 18.7227 4.55042C18.7988 4.54542 18.8749 4.56142 18.9425 4.59666C19.0102 4.63191 19.0669 4.68505 19.1064 4.7503C19.1459 4.81554 19.1668 4.89039 19.1667 4.96667V15.0333C19.1668 15.1096 19.1459 15.1845 19.1064 15.2497C19.0669 15.315 19.0102 15.3681 18.9425 15.4033C18.8749 15.4386 18.7988 15.4546 18.7227 15.4496C18.6466 15.4446 18.5733 15.4188 18.5108 15.375L14.1667 12.3333V15.8333C14.1667 16.0543 14.0789 16.2663 13.9226 16.4226C13.7663 16.5789 13.5544 16.6667 13.3333 16.6667H1.66668C1.44566 16.6667 1.2337 16.5789 1.07742 16.4226C0.921141 16.2663 0.833344 16.0543 0.833344 15.8333V4.16667C0.833344 3.94566 0.921141 3.73369 1.07742 3.57741C1.2337 3.42113 1.44566 3.33334 1.66668 3.33334H13.3333C13.5544 3.33334 13.7663 3.42113 13.9226 3.57741C14.0789 3.73369 14.1667 3.94566 14.1667 4.16667V7.66667ZM4.16668 6.66667V8.33334H5.83334V6.66667H4.16668Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_139_241">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}

export function VideocamCasinosky() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.14286 2.85714C0.95939 2.85714 0 3.81653 0 5V15C0 16.1834 0.95939 17.1429 2.14286 17.1429H12.8571C14.0406 17.1429 15 16.1834 15 15V13.9404L18.0087 15.2299C18.9513 15.6339 20 14.9423 20 13.9168V6.08324C20 5.05764 18.9513 4.36617 18.0087 4.77017L15 6.05961V5C15 3.81653 14.0406 2.85714 12.8571 2.85714H2.14286Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function VideocamPlayboomDisabled() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4426 14.4311C14.3678 15.8087 13.2791 16.9086 11.9018 16.9891C10.5772 17.0666 9.21168 17.1072 7.8164 17.1072C6.42111 17.1072 5.05562 17.0666 3.73097 16.9891C2.35371 16.9085 1.26497 15.8087 1.19014 14.4311C1.11218 12.9959 1.07138 11.5146 1.07138 10C1.07138 8.48541 1.11218 7.00413 1.19014 5.5689C1.26497 4.19131 2.35372 3.09144 3.73098 3.01085C5.05562 2.93334 6.42111 2.89284 7.8164 2.89284C9.21168 2.89284 10.5772 2.93334 11.9018 3.01085C13.279 3.09144 14.3678 4.19131 14.4426 5.5689C14.4673 6.0225 14.4882 6.4807 14.5053 6.9431L18.9285 4.97722V15.0323L14.505 13.0662C14.4879 13.5255 14.4671 13.9805 14.4426 14.4311Z"
        fill="#FAFAFA"
        stroke="white"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}

export function VideocamPlayboomDefault() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4426 14.4311C14.3678 15.8087 13.2791 16.9086 11.9018 16.9891C10.5772 17.0666 9.21168 17.1072 7.8164 17.1072C6.42111 17.1072 5.05562 17.0666 3.73097 16.9891C2.35371 16.9085 1.26497 15.8087 1.19014 14.4311C1.11218 12.9959 1.07138 11.5146 1.07138 10C1.07138 8.48541 1.11218 7.00413 1.19014 5.5689C1.26497 4.19131 2.35372 3.09144 3.73098 3.01085C5.05562 2.93334 6.42111 2.89284 7.8164 2.89284C9.21168 2.89284 10.5772 2.93334 11.9018 3.01085C13.279 3.09144 14.3678 4.19131 14.4426 5.5689C14.4673 6.0225 14.4882 6.4807 14.5053 6.9431L18.9285 4.97722V15.0323L14.505 13.0662C14.4879 13.5255 14.4671 13.9805 14.4426 14.4311Z"
        fill="#716377"
        stroke="#9E8FA3"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}

export function VideocamPlayboomActive() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.68717 2.26213C5.02655 2.18376 6.40665 2.14284 7.8164 2.14284C9.22614 2.14284 10.6062 2.18376 11.9456 2.26213C13.7062 2.36515 15.0961 3.77203 15.1915 5.52821C15.1966 5.62221 15.2016 5.7164 15.2064 5.81077L18.6239 4.29186C18.8559 4.18875 19.1243 4.21001 19.3372 4.34835C19.5501 4.48669 19.6785 4.72334 19.6785 4.97722V15.0323C19.6785 15.2861 19.5501 15.5228 19.3372 15.6611C19.1243 15.7995 18.8559 15.8207 18.6239 15.7176L15.2059 14.1985C15.2013 14.2898 15.1965 14.3809 15.1915 14.4718C15.0961 16.228 13.7062 17.6348 11.9456 17.7379C10.6062 17.8162 9.22614 17.8572 7.8164 17.8572C6.40664 17.8572 5.02655 17.8162 3.68716 17.7379C1.92658 17.6348 0.536639 16.228 0.441243 14.4718C0.362538 13.0229 0.321381 11.528 0.321381 10C0.321381 8.472 0.362539 6.97715 0.441247 5.52822C0.536645 3.77203 1.92658 2.36515 3.68717 2.26213ZM7.8164 3.64284C6.43557 3.64284 5.08469 3.68292 3.77479 3.75957C2.78085 3.81773 1.9933 4.61059 1.93904 5.60958C1.86182 7.03111 1.82138 8.49883 1.82138 10C1.82138 11.5012 1.86182 12.9689 1.93904 14.3904C1.9933 15.3894 2.78085 16.1823 3.77478 16.2404C5.08469 16.3171 6.43557 16.3572 7.8164 16.3572C9.19722 16.3572 10.5481 16.3171 11.858 16.2404C12.8519 16.1823 13.6395 15.3894 13.6937 14.3904C13.718 13.9442 13.7386 13.4934 13.7555 13.0384C13.7647 12.7896 13.8968 12.5617 14.108 12.4299C14.3192 12.2981 14.5821 12.2798 14.8096 12.3809L18.1785 13.8782V6.13129L14.8099 7.62846C14.5824 7.72957 14.3195 7.7112 14.1083 7.57941C13.8971 7.44763 13.765 7.21961 13.7558 6.97082C13.7389 6.51271 13.7181 6.05883 13.6937 5.60958C13.6395 4.61059 12.8519 3.81773 11.858 3.75957C10.5481 3.68292 9.19722 3.64284 7.8164 3.64284Z"
        fill="url(#paint0_linear_113_1121)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_113_1121"
          x1="1.27741"
          y1="4.2571"
          x2="14.838"
          y2="22.2248"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.29" stopColor="#FFA267" />
          <stop offset="0.48" stopColor="#FF7154" />
        </linearGradient>
      </defs>
    </SvgIcon>
  )
}

export function PragmaticPlayboomDisabled() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4426 14.4311C14.3678 15.8087 13.2791 16.9086 11.9018 16.9891C10.5772 17.0666 9.21168 17.1072 7.8164 17.1072C6.42111 17.1072 5.05562 17.0666 3.73097 16.9891C2.35371 16.9085 1.26497 15.8087 1.19014 14.4311C1.11218 12.9959 1.07138 11.5146 1.07138 10C1.07138 8.48541 1.11218 7.00413 1.19014 5.5689C1.26497 4.19131 2.35372 3.09144 3.73098 3.01085C5.05562 2.93334 6.42111 2.89284 7.8164 2.89284C9.21168 2.89284 10.5772 2.93334 11.9018 3.01085C13.279 3.09144 14.3678 4.19131 14.4426 5.5689C14.4673 6.0225 14.4882 6.4807 14.5053 6.9431L18.9285 4.97722V15.0323L14.505 13.0662C14.4879 13.5255 14.4671 13.9805 14.4426 14.4311Z"
        fill="#FAFAFA"
        stroke="white"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}

export function PragmaticPlayboomDefault() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4426 14.4311C14.3678 15.8087 13.2791 16.9086 11.9018 16.9891C10.5772 17.0666 9.21168 17.1072 7.8164 17.1072C6.42111 17.1072 5.05562 17.0666 3.73097 16.9891C2.35371 16.9085 1.26497 15.8087 1.19014 14.4311C1.11218 12.9959 1.07138 11.5146 1.07138 10C1.07138 8.48541 1.11218 7.00413 1.19014 5.5689C1.26497 4.19131 2.35372 3.09144 3.73098 3.01085C5.05562 2.93334 6.42111 2.89284 7.8164 2.89284C9.21168 2.89284 10.5772 2.93334 11.9018 3.01085C13.279 3.09144 14.3678 4.19131 14.4426 5.5689C14.4673 6.0225 14.4882 6.4807 14.5053 6.9431L18.9285 4.97722V15.0323L14.505 13.0662C14.4879 13.5255 14.4671 13.9805 14.4426 14.4311Z"
        fill="#716377"
        stroke="#9E8FA3"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}

export function PragmaticPlayboomActive() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.68717 2.26213C5.02655 2.18376 6.40665 2.14284 7.8164 2.14284C9.22614 2.14284 10.6062 2.18376 11.9456 2.26213C13.7062 2.36515 15.0961 3.77203 15.1915 5.52821C15.1966 5.62221 15.2016 5.7164 15.2064 5.81077L18.6239 4.29186C18.8559 4.18875 19.1243 4.21001 19.3372 4.34835C19.5501 4.48669 19.6785 4.72334 19.6785 4.97722V15.0323C19.6785 15.2861 19.5501 15.5228 19.3372 15.6611C19.1243 15.7995 18.8559 15.8207 18.6239 15.7176L15.2059 14.1985C15.2013 14.2898 15.1965 14.3809 15.1915 14.4718C15.0961 16.228 13.7062 17.6348 11.9456 17.7379C10.6062 17.8162 9.22614 17.8572 7.8164 17.8572C6.40664 17.8572 5.02655 17.8162 3.68716 17.7379C1.92658 17.6348 0.536639 16.228 0.441243 14.4718C0.362538 13.0229 0.321381 11.528 0.321381 10C0.321381 8.472 0.362539 6.97715 0.441247 5.52822C0.536645 3.77203 1.92658 2.36515 3.68717 2.26213ZM7.8164 3.64284C6.43557 3.64284 5.08469 3.68292 3.77479 3.75957C2.78085 3.81773 1.9933 4.61059 1.93904 5.60958C1.86182 7.03111 1.82138 8.49883 1.82138 10C1.82138 11.5012 1.86182 12.9689 1.93904 14.3904C1.9933 15.3894 2.78085 16.1823 3.77478 16.2404C5.08469 16.3171 6.43557 16.3572 7.8164 16.3572C9.19722 16.3572 10.5481 16.3171 11.858 16.2404C12.8519 16.1823 13.6395 15.3894 13.6937 14.3904C13.718 13.9442 13.7386 13.4934 13.7555 13.0384C13.7647 12.7896 13.8968 12.5617 14.108 12.4299C14.3192 12.2981 14.5821 12.2798 14.8096 12.3809L18.1785 13.8782V6.13129L14.8099 7.62846C14.5824 7.72957 14.3195 7.7112 14.1083 7.57941C13.8971 7.44763 13.765 7.21961 13.7558 6.97082C13.7389 6.51271 13.7181 6.05883 13.6937 5.60958C13.6395 4.61059 12.8519 3.81773 11.858 3.75957C10.5481 3.68292 9.19722 3.64284 7.8164 3.64284Z"
        fill="url(#paint0_linear_pragmatic_113_1121)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_pragmatic_113_1121"
          x1="1.27741"
          y1="4.2571"
          x2="14.838"
          y2="22.2248"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.29" stopColor="#FFA267" />
          <stop offset="0.48" stopColor="#FF7154" />
        </linearGradient>
      </defs>
    </SvgIcon>
  )
}

export function ViewModule() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M4 11h5V5H4v6zm0 7h5v-6H4v6zm6 0h5v-6h-5v6zm6 0h5v-6h-5v6zm-6-7h5V5h-5v6zm6-6v6h5V5h-5z"
      />
    </SvgIcon>
  )
}

export function ViewModuleWettenlive() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.9375 1.875H2.1875C2.01491 1.875 1.875 2.01491 1.875 2.1875V5.9375C1.875 6.11009 2.01491 6.25 2.1875 6.25H5.9375C6.11009 6.25 6.25 6.11009 6.25 5.9375V2.1875C6.25 2.01491 6.11009 1.875 5.9375 1.875Z"
        fill="currentColor"
      />
      <path
        d="M11.875 1.875H8.125C7.95241 1.875 7.8125 2.01491 7.8125 2.1875V5.9375C7.8125 6.11009 7.95241 6.25 8.125 6.25H11.875C12.0476 6.25 12.1875 6.11009 12.1875 5.9375V2.1875C12.1875 2.01491 12.0476 1.875 11.875 1.875Z"
        fill="currentColor"
      />
      <path
        d="M17.8125 1.875H14.0625C13.8899 1.875 13.75 2.01491 13.75 2.1875V5.9375C13.75 6.11009 13.8899 6.25 14.0625 6.25H17.8125C17.9851 6.25 18.125 6.11009 18.125 5.9375V2.1875C18.125 2.01491 17.9851 1.875 17.8125 1.875Z"
        fill="currentColor"
      />
      <path
        d="M5.9375 7.8125H2.1875C2.01491 7.8125 1.875 7.95241 1.875 8.125V11.875C1.875 12.0476 2.01491 12.1875 2.1875 12.1875H5.9375C6.11009 12.1875 6.25 12.0476 6.25 11.875V8.125C6.25 7.95241 6.11009 7.8125 5.9375 7.8125Z"
        fill="currentColor"
      />
      <path
        d="M11.875 7.8125H8.125C7.95241 7.8125 7.8125 7.95241 7.8125 8.125V11.875C7.8125 12.0476 7.95241 12.1875 8.125 12.1875H11.875C12.0476 12.1875 12.1875 12.0476 12.1875 11.875V8.125C12.1875 7.95241 12.0476 7.8125 11.875 7.8125Z"
        fill="currentColor"
      />
      <path
        d="M17.8125 7.8125H14.0625C13.8899 7.8125 13.75 7.95241 13.75 8.125V11.875C13.75 12.0476 13.8899 12.1875 14.0625 12.1875H17.8125C17.9851 12.1875 18.125 12.0476 18.125 11.875V8.125C18.125 7.95241 17.9851 7.8125 17.8125 7.8125Z"
        fill="currentColor"
      />
      <path
        d="M5.9375 13.75H2.1875C2.01491 13.75 1.875 13.8899 1.875 14.0625V17.8125C1.875 17.9851 2.01491 18.125 2.1875 18.125H5.9375C6.11009 18.125 6.25 17.9851 6.25 17.8125V14.0625C6.25 13.8899 6.11009 13.75 5.9375 13.75Z"
        fill="currentColor"
      />
      <path
        d="M11.875 13.75H8.125C7.95241 13.75 7.8125 13.8899 7.8125 14.0625V17.8125C7.8125 17.9851 7.95241 18.125 8.125 18.125H11.875C12.0476 18.125 12.1875 17.9851 12.1875 17.8125V14.0625C12.1875 13.8899 12.0476 13.75 11.875 13.75Z"
        fill="currentColor"
      />
      <path
        d="M17.8125 13.75H14.0625C13.8899 13.75 13.75 13.8899 13.75 14.0625V17.8125C13.75 17.9851 13.8899 18.125 14.0625 18.125H17.8125C17.9851 18.125 18.125 17.9851 18.125 17.8125V14.0625C18.125 13.8899 17.9851 13.75 17.8125 13.75Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function ViewModuleCasinosky() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.0837402"
        y="2.45752"
        width="5.87298"
        height="6.99927"
        rx="1"
        fill="currentColor"
      />
      <rect
        x="0.0837402"
        y="10.5432"
        width="5.87298"
        height="6.99927"
        rx="1"
        fill="currentColor"
      />
      <rect
        x="7.00403"
        y="2.45752"
        width="5.87298"
        height="6.99927"
        rx="1"
        fill="currentColor"
      />
      <rect
        x="7.00403"
        y="10.5432"
        width="5.87298"
        height="6.99927"
        rx="1"
        fill="currentColor"
      />
      <rect
        x="13.9243"
        y="2.45752"
        width="5.87298"
        height="6.99927"
        rx="1"
        fill="currentColor"
      />
      <rect
        x="13.9243"
        y="10.5432"
        width="5.87298"
        height="6.99927"
        rx="1"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function ViewModulePlayboomDisabled() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.02571 7.67079C8.07333 8.16928 8.43131 8.57021 8.87618 8.62575C9.20661 8.667 9.54588 8.70243 9.89178 8.70243C10.2377 8.70243 10.577 8.667 10.9074 8.62575C11.3523 8.57021 11.7102 8.16928 11.7579 7.67079C11.793 7.30279 11.8227 6.92499 11.8227 6.53981C11.8227 6.15464 11.793 5.77684 11.7579 5.40884C11.7102 4.91035 11.3523 4.50942 10.9074 4.45388C10.577 4.41263 10.2377 4.3772 9.89178 4.3772C9.54588 4.3772 9.20661 4.41263 8.87618 4.45388C8.43131 4.50942 8.07333 4.91035 8.02571 5.40884C7.99056 5.77684 7.96088 6.15464 7.96088 6.53981C7.96088 6.92499 7.99056 7.30279 8.02571 7.67079Z"
        fill="#F9F9F9"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M1.95859 7.67079C2.00621 8.16928 2.36419 8.57021 2.80905 8.62575C3.13948 8.667 3.47876 8.70243 3.82466 8.70243C4.17057 8.70243 4.50984 8.667 4.84027 8.62575C5.28514 8.57021 5.64311 8.16928 5.69073 7.67079C5.72588 7.30279 5.75557 6.92499 5.75557 6.53981C5.75557 6.15464 5.72588 5.77684 5.69073 5.40884C5.64311 4.91035 5.28514 4.50942 4.84027 4.45388C4.50984 4.41263 4.17057 4.3772 3.82466 4.3772C3.47876 4.3772 3.13948 4.41263 2.80905 4.45388C2.36419 4.50942 2.00621 4.91035 1.95859 5.40884C1.92344 5.77684 1.89375 6.15464 1.89375 6.53981C1.89375 6.92499 1.92344 7.30279 1.95859 7.67079Z"
        fill="#F9F9F9"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M1.95856 14.5912C2.00618 15.0897 2.36415 15.4906 2.80902 15.5462C3.13945 15.5874 3.47872 15.6228 3.82463 15.6228C4.17054 15.6228 4.50981 15.5874 4.84024 15.5462C5.28511 15.4906 5.64308 15.0897 5.6907 14.5912C5.72585 14.2232 5.75554 13.8454 5.75554 13.4602C5.75554 13.0751 5.72585 12.6972 5.6907 12.3293C5.64308 11.8308 5.28511 11.4298 4.84024 11.3743C4.50981 11.333 4.17054 11.2976 3.82463 11.2976C3.47873 11.2976 3.13945 11.333 2.80902 11.3743C2.36415 11.4298 2.00618 11.8308 1.95856 12.3293C1.92341 12.6972 1.89372 13.0751 1.89372 13.4602C1.89372 13.8454 1.92341 14.2232 1.95856 14.5912Z"
        fill="#F9F9F9"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M8.0257 14.5912C8.07332 15.0897 8.43129 15.4906 8.87616 15.5462C9.20659 15.5874 9.54586 15.6228 9.89177 15.6228C10.2377 15.6228 10.5769 15.5874 10.9074 15.5462C11.3522 15.4906 11.7102 15.0897 11.7578 14.5912C11.793 14.2232 11.8227 13.8454 11.8227 13.4602C11.8227 13.0751 11.793 12.6972 11.7578 12.3293C11.7102 11.8308 11.3522 11.4298 10.9074 11.3743C10.5769 11.333 10.2377 11.2976 9.89177 11.2976C9.54586 11.2976 9.20659 11.333 8.87616 11.3743C8.43129 11.4298 8.07332 11.8308 8.0257 12.3293C7.99055 12.6972 7.96086 13.0751 7.96086 13.4602C7.96086 13.8454 7.99055 14.2232 8.0257 14.5912Z"
        fill="#F9F9F9"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M14.2806 7.67079C14.3282 8.16928 14.6861 8.57021 15.131 8.62575C15.4614 8.667 15.8007 8.70243 16.1466 8.70243C16.4925 8.70243 16.8318 8.667 17.1622 8.62575C17.6071 8.57021 17.9651 8.16928 18.0127 7.67079C18.0478 7.30279 18.0775 6.92499 18.0775 6.53981C18.0775 6.15464 18.0478 5.77684 18.0127 5.40884C17.9651 4.91035 17.6071 4.50942 17.1622 4.45388C16.8318 4.41263 16.4925 4.3772 16.1466 4.3772C15.8007 4.3772 15.4614 4.41263 15.131 4.45388C14.6861 4.50942 14.3282 4.91035 14.2806 5.40884C14.2454 5.77684 14.2157 6.15464 14.2157 6.53981C14.2157 6.92499 14.2454 7.30279 14.2806 7.67079Z"
        fill="#F9F9F9"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M14.2805 14.5912C14.3281 15.0897 14.6861 15.4906 15.131 15.5462C15.4614 15.5874 15.8007 15.6228 16.1466 15.6228C16.4925 15.6228 16.8318 15.5874 17.1622 15.5462C17.6071 15.4906 17.965 15.0897 18.0126 14.5912C18.0478 14.2232 18.0775 13.8454 18.0775 13.4602C18.0775 13.0751 18.0478 12.6972 18.0126 12.3293C17.965 11.8308 17.6071 11.4298 17.1622 11.3743C16.8318 11.333 16.4925 11.2976 16.1466 11.2976C15.8007 11.2976 15.4614 11.333 15.131 11.3743C14.6861 11.4298 14.3281 11.8308 14.2805 12.3293C14.2454 12.6972 14.2157 13.0751 14.2157 13.4602C14.2157 13.8454 14.2454 14.2232 14.2805 14.5912Z"
        fill="#F9F9F9"
        stroke="white"
        strokeWidth="1.5"
      />
    </SvgIcon>
  )
}

export function ViewModulePlayboomDefault() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.02571 8.17079C8.07333 8.66928 8.43131 9.07021 8.87618 9.12575C9.20661 9.167 9.54588 9.20243 9.89178 9.20243C10.2377 9.20243 10.577 9.167 10.9074 9.12575C11.3523 9.07021 11.7102 8.66928 11.7579 8.17079C11.793 7.80279 11.8227 7.42499 11.8227 7.03981C11.8227 6.65464 11.793 6.27684 11.7579 5.90884C11.7102 5.41035 11.3523 5.00942 10.9074 4.95388C10.577 4.91263 10.2377 4.8772 9.89178 4.8772C9.54588 4.8772 9.20661 4.91263 8.87618 4.95388C8.43131 5.00942 8.07333 5.41035 8.02571 5.90884C7.99056 6.27684 7.96088 6.65464 7.96088 7.03981C7.96088 7.42499 7.99056 7.80279 8.02571 8.17079Z"
        fill="#716377"
        stroke="#9E8FA3"
        strokeWidth="1.5"
      />
      <path
        d="M1.95859 8.17079C2.00621 8.66928 2.36419 9.07021 2.80905 9.12575C3.13948 9.167 3.47876 9.20243 3.82466 9.20243C4.17057 9.20243 4.50984 9.167 4.84027 9.12575C5.28514 9.07021 5.64311 8.66928 5.69073 8.17079C5.72588 7.80279 5.75557 7.42499 5.75557 7.03981C5.75557 6.65464 5.72588 6.27684 5.69073 5.90884C5.64311 5.41035 5.28514 5.00942 4.84027 4.95388C4.50984 4.91263 4.17057 4.8772 3.82466 4.8772C3.47876 4.8772 3.13948 4.91263 2.80905 4.95388C2.36419 5.00942 2.00621 5.41035 1.95859 5.90884C1.92344 6.27684 1.89375 6.65464 1.89375 7.03981C1.89375 7.42499 1.92344 7.80279 1.95859 8.17079Z"
        fill="#716377"
        stroke="#9E8FA3"
        strokeWidth="1.5"
      />
      <path
        d="M1.95856 15.0912C2.00618 15.5897 2.36415 15.9906 2.80902 16.0462C3.13945 16.0874 3.47872 16.1228 3.82463 16.1228C4.17054 16.1228 4.50981 16.0874 4.84024 16.0462C5.28511 15.9906 5.64308 15.5897 5.6907 15.0912C5.72585 14.7232 5.75554 14.3454 5.75554 13.9602C5.75554 13.5751 5.72585 13.1972 5.6907 12.8293C5.64308 12.3308 5.28511 11.9298 4.84024 11.8743C4.50981 11.833 4.17054 11.7976 3.82463 11.7976C3.47873 11.7976 3.13945 11.833 2.80902 11.8743C2.36415 11.9298 2.00618 12.3308 1.95856 12.8293C1.92341 13.1972 1.89372 13.5751 1.89372 13.9602C1.89372 14.3454 1.92341 14.7232 1.95856 15.0912Z"
        fill="#716377"
        stroke="#9E8FA3"
        strokeWidth="1.5"
      />
      <path
        d="M8.0257 15.0912C8.07332 15.5897 8.43129 15.9906 8.87616 16.0462C9.20659 16.0874 9.54586 16.1228 9.89177 16.1228C10.2377 16.1228 10.5769 16.0874 10.9074 16.0462C11.3522 15.9906 11.7102 15.5897 11.7578 15.0912C11.793 14.7232 11.8227 14.3454 11.8227 13.9602C11.8227 13.5751 11.793 13.1972 11.7578 12.8293C11.7102 12.3308 11.3522 11.9298 10.9074 11.8743C10.5769 11.833 10.2377 11.7976 9.89177 11.7976C9.54586 11.7976 9.20659 11.833 8.87616 11.8743C8.43129 11.9298 8.07332 12.3308 8.0257 12.8293C7.99055 13.1972 7.96086 13.5751 7.96086 13.9602C7.96086 14.3454 7.99055 14.7232 8.0257 15.0912Z"
        fill="#716377"
        stroke="#9E8FA3"
        strokeWidth="1.5"
      />
      <path
        d="M14.2806 8.17079C14.3282 8.66928 14.6861 9.07021 15.131 9.12575C15.4614 9.167 15.8007 9.20243 16.1466 9.20243C16.4925 9.20243 16.8318 9.167 17.1622 9.12575C17.6071 9.07021 17.9651 8.66928 18.0127 8.17079C18.0478 7.80279 18.0775 7.42499 18.0775 7.03981C18.0775 6.65464 18.0478 6.27684 18.0127 5.90884C17.9651 5.41035 17.6071 5.00942 17.1622 4.95388C16.8318 4.91263 16.4925 4.8772 16.1466 4.8772C15.8007 4.8772 15.4614 4.91263 15.131 4.95388C14.6861 5.00942 14.3282 5.41035 14.2806 5.90884C14.2454 6.27684 14.2157 6.65464 14.2157 7.03981C14.2157 7.42499 14.2454 7.80279 14.2806 8.17079Z"
        fill="#716377"
        stroke="#9E8FA3"
        strokeWidth="1.5"
      />
      <path
        d="M14.2805 15.0912C14.3281 15.5897 14.6861 15.9906 15.131 16.0462C15.4614 16.0874 15.8007 16.1228 16.1466 16.1228C16.4925 16.1228 16.8318 16.0874 17.1622 16.0462C17.6071 15.9906 17.965 15.5897 18.0126 15.0912C18.0478 14.7232 18.0775 14.3454 18.0775 13.9602C18.0775 13.5751 18.0478 13.1972 18.0126 12.8293C17.965 12.3308 17.6071 11.9298 17.1622 11.8743C16.8318 11.833 16.4925 11.7976 16.1466 11.7976C15.8007 11.7976 15.4614 11.833 15.131 11.8743C14.6861 11.9298 14.3281 12.3308 14.2805 12.8293C14.2454 13.1972 14.2157 13.5751 14.2157 13.9602C14.2157 14.3454 14.2454 14.7232 14.2805 15.0912Z"
        fill="#716377"
        stroke="#9E8FA3"
        strokeWidth="1.5"
      />
    </SvgIcon>
  )
}

export function ViewModulePlayboomActive() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.90191 5.6981C3.22521 5.65774 3.52689 5.6272 3.82462 5.6272C4.12234 5.6272 4.42402 5.65774 4.74732 5.6981C4.77028 5.70097 4.81074 5.71514 4.85452 5.76426C4.89847 5.81357 4.9353 5.88824 4.94408 5.98016C4.97862 6.34168 5.00552 6.69107 5.00552 7.03981C5.00552 7.38856 4.97862 7.73794 4.94408 8.09947C4.9353 8.19139 4.89847 8.26606 4.85452 8.31537C4.81074 8.36449 4.77028 8.37866 4.74732 8.38153C4.42402 8.42189 4.12234 8.45243 3.82462 8.45243C3.52689 8.45243 3.22521 8.42189 2.90192 8.38153C2.87895 8.37866 2.83849 8.36449 2.79471 8.31537C2.75076 8.26606 2.71393 8.19139 2.70515 8.09947C2.67061 7.73794 2.64371 7.38856 2.64371 7.03981C2.64371 6.69107 2.67061 6.34168 2.70515 5.98016C2.71393 5.88824 2.75076 5.81357 2.79471 5.76426C2.83849 5.71514 2.87895 5.70097 2.90191 5.6981ZM3.82462 4.1272C3.43053 4.1272 3.05366 4.16751 2.7161 4.20966C1.86947 4.31535 1.28759 5.04557 1.21194 5.83752C1.17617 6.21199 1.14371 6.61821 1.14371 7.03981C1.14371 7.46142 1.17617 7.86764 1.21194 8.24211C1.28759 9.03405 1.86947 9.76428 2.7161 9.86997C3.05366 9.91212 3.43053 9.95243 3.82462 9.95243C4.2187 9.95243 4.59557 9.91212 4.93313 9.86997C5.77976 9.76428 6.36164 9.03405 6.43729 8.24211C6.47306 7.86764 6.50552 7.46142 6.50552 7.03981C6.50552 6.61821 6.47306 6.21199 6.43729 5.83752C6.36164 5.04557 5.77976 4.31535 4.93313 4.20966C4.59557 4.16751 4.21871 4.1272 3.82462 4.1272ZM8.96905 5.6981C9.29235 5.65774 9.59403 5.6272 9.89175 5.6272C10.1895 5.6272 10.4912 5.65774 10.8145 5.6981C10.8374 5.70097 10.8779 5.71514 10.9217 5.76426C10.9656 5.81357 11.0024 5.88824 11.0112 5.98016C11.0458 6.34168 11.0727 6.69107 11.0727 7.03981C11.0727 7.38856 11.0458 7.73794 11.0112 8.09947C11.0024 8.19139 10.9656 8.26606 10.9217 8.31537C10.8779 8.36449 10.8374 8.37866 10.8145 8.38153C10.4912 8.42189 10.1895 8.45243 9.89175 8.45243C9.59403 8.45243 9.29235 8.42189 8.96905 8.38153C8.94609 8.37866 8.90563 8.36449 8.86185 8.31537C8.8179 8.26606 8.78107 8.19139 8.77228 8.09947C8.73775 7.73794 8.71085 7.38856 8.71085 7.03981C8.71085 6.69107 8.73775 6.34168 8.77228 5.98016C8.78107 5.88824 8.8179 5.81357 8.86185 5.76426C8.90563 5.71514 8.94609 5.70097 8.96905 5.6981ZM9.89175 4.1272C9.49766 4.1272 9.1208 4.16751 8.78324 4.20966C7.93661 4.31535 7.35473 5.04557 7.27908 5.83752C7.24331 6.21199 7.21085 6.61821 7.21085 7.03981C7.21085 7.46142 7.24331 7.86764 7.27908 8.24211C7.35473 9.03405 7.93661 9.76428 8.78324 9.86997C9.1208 9.91212 9.49766 9.95243 9.89175 9.95243C10.2858 9.95243 10.6627 9.91212 11.0003 9.86997C11.8469 9.76428 12.4288 9.03405 12.5044 8.24211C12.5402 7.86764 12.5727 7.46142 12.5727 7.03981C12.5727 6.61821 12.5402 6.21199 12.5044 5.83752C12.4288 5.04557 11.8469 4.31535 11.0003 4.20966C10.6627 4.16751 10.2858 4.1272 9.89175 4.1272ZM3.82462 12.5476C3.52689 12.5476 3.22521 12.5782 2.90191 12.6185C2.87895 12.6214 2.83849 12.6356 2.79471 12.6847C2.75076 12.734 2.71393 12.8087 2.70515 12.9006C2.67061 13.2621 2.64371 13.6115 2.64371 13.9602C2.64371 14.309 2.67061 14.6584 2.70515 15.0199C2.71393 15.1118 2.75076 15.1865 2.79471 15.2358C2.83849 15.2849 2.87895 15.2991 2.90192 15.3019C3.22521 15.3423 3.52689 15.3728 3.82462 15.3728C4.12234 15.3728 4.42402 15.3423 4.74732 15.3019C4.77028 15.2991 4.81074 15.2849 4.85452 15.2358C4.89847 15.1865 4.9353 15.1118 4.94408 15.0199C4.97862 14.6584 5.00552 14.309 5.00552 13.9602C5.00552 13.6115 4.97862 13.2621 4.94408 12.9006C4.9353 12.8087 4.89847 12.734 4.85452 12.6847C4.81074 12.6356 4.77028 12.6214 4.74732 12.6185C4.42402 12.5782 4.12234 12.5476 3.82462 12.5476ZM2.7161 11.1301C3.05366 11.0879 3.43053 11.0476 3.82462 11.0476C4.21871 11.0476 4.59557 11.0879 4.93313 11.1301C5.77976 11.2358 6.36164 11.966 6.43729 12.7579C6.47306 13.1324 6.50552 13.5386 6.50552 13.9602C6.50552 14.3818 6.47306 14.788 6.43729 15.1625C6.36164 15.9545 5.77976 16.6847 4.93313 16.7904C4.59557 16.8325 4.2187 16.8728 3.82462 16.8728C3.43053 16.8728 3.05366 16.8325 2.7161 16.7904C1.86947 16.6847 1.28759 15.9545 1.21194 15.1625C1.17617 14.788 1.14371 14.3818 1.14371 13.9602C1.14371 13.5386 1.17617 13.1324 1.21194 12.7579C1.28759 11.966 1.86947 11.2358 2.7161 11.1301ZM8.96905 12.6185C9.29235 12.5782 9.59403 12.5476 9.89175 12.5476C10.1895 12.5476 10.4912 12.5782 10.8145 12.6185C10.8374 12.6214 10.8779 12.6356 10.9217 12.6847C10.9656 12.734 11.0024 12.8087 11.0112 12.9006C11.0458 13.2621 11.0727 13.6115 11.0727 13.9602C11.0727 14.309 11.0458 14.6584 11.0112 15.0199C11.0024 15.1118 10.9656 15.1865 10.9217 15.2358C10.8779 15.2849 10.8374 15.2991 10.8145 15.3019C10.4912 15.3423 10.1895 15.3728 9.89175 15.3728C9.59403 15.3728 9.29235 15.3423 8.96905 15.3019C8.94609 15.2991 8.90563 15.2849 8.86185 15.2358C8.8179 15.1865 8.78107 15.1118 8.77228 15.0199C8.73775 14.6584 8.71085 14.309 8.71085 13.9602C8.71085 13.6115 8.73775 13.2621 8.77228 12.9006C8.78107 12.8087 8.8179 12.734 8.86185 12.6847C8.90563 12.6356 8.94609 12.6214 8.96905 12.6185ZM9.89175 11.0476C9.49766 11.0476 9.1208 11.0879 8.78324 11.1301C7.93661 11.2358 7.35473 11.966 7.27908 12.7579C7.24331 13.1324 7.21085 13.5386 7.21085 13.9602C7.21085 14.3818 7.24331 14.788 7.27908 15.1625C7.35473 15.9545 7.93661 16.6847 8.78324 16.7904C9.1208 16.8325 9.49766 16.8728 9.89175 16.8728C10.2858 16.8728 10.6627 16.8325 11.0003 16.7904C11.8469 16.6847 12.4288 15.9545 12.5044 15.1625C12.5402 14.788 12.5727 14.3818 12.5727 13.9602C12.5727 13.5386 12.5402 13.1324 12.5044 12.7579C12.4288 11.966 11.8469 11.2358 11.0003 11.1301C10.6627 11.0879 10.2858 11.0476 9.89175 11.0476ZM16.1466 5.6272C15.8489 5.6272 15.5472 5.65774 15.2239 5.6981C15.201 5.70097 15.1605 5.71514 15.1167 5.76426C15.0728 5.81357 15.0359 5.88824 15.0272 5.98016C14.9926 6.34168 14.9657 6.69107 14.9657 7.03981C14.9657 7.38856 14.9926 7.73794 15.0272 8.09947C15.0359 8.19139 15.0728 8.26606 15.1167 8.31537C15.1605 8.36449 15.201 8.37866 15.2239 8.38153C15.5472 8.42189 15.8489 8.45243 16.1466 8.45243C16.4444 8.45243 16.746 8.42189 17.0693 8.38153C17.0923 8.37866 17.1328 8.36449 17.1765 8.31537C17.2205 8.26606 17.2573 8.19139 17.2661 8.09947C17.3006 7.73794 17.3275 7.38856 17.3275 7.03981C17.3275 6.69107 17.3006 6.34168 17.2661 5.98016C17.2573 5.88824 17.2205 5.81357 17.1765 5.76426C17.1328 5.71514 17.0923 5.70097 17.0693 5.6981C16.746 5.65774 16.4444 5.6272 16.1466 5.6272ZM15.0381 4.20966C15.3757 4.16751 15.7525 4.1272 16.1466 4.1272C16.5407 4.1272 16.9176 4.16751 17.2552 4.20966C18.1018 4.31535 18.6837 5.04557 18.7593 5.83752C18.7951 6.21199 18.8275 6.61821 18.8275 7.03981C18.8275 7.46142 18.7951 7.86764 18.7593 8.24211C18.6837 9.03405 18.1018 9.76428 17.2552 9.86997C16.9176 9.91212 16.5407 9.95243 16.1466 9.95243C15.7525 9.95243 15.3757 9.91212 15.0381 9.86997C14.1915 9.76428 13.6096 9.03405 13.534 8.24211C13.4982 7.86764 13.4657 7.46142 13.4657 7.03981C13.4657 6.61821 13.4982 6.21199 13.534 5.83752C13.6096 5.04557 14.1915 4.31535 15.0381 4.20966ZM15.2239 12.6185C15.5472 12.5782 15.8489 12.5476 16.1466 12.5476C16.4444 12.5476 16.746 12.5782 17.0693 12.6185C17.0923 12.6214 17.1328 12.6356 17.1765 12.6847C17.2205 12.734 17.2573 12.8087 17.2661 12.9006C17.3006 13.2621 17.3275 13.6115 17.3275 13.9602C17.3275 14.309 17.3006 14.6584 17.2661 15.0199C17.2573 15.1118 17.2205 15.1865 17.1765 15.2358C17.1328 15.2849 17.0923 15.2991 17.0693 15.3019C16.746 15.3423 16.4444 15.3728 16.1466 15.3728C15.8489 15.3728 15.5472 15.3423 15.2239 15.3019C15.201 15.2991 15.1605 15.2849 15.1167 15.2358C15.0728 15.1865 15.0359 15.1118 15.0272 15.0199C14.9926 14.6584 14.9657 14.309 14.9657 13.9602C14.9657 13.6115 14.9926 13.2621 15.0272 12.9006C15.0359 12.8087 15.0728 12.734 15.1167 12.6847C15.1605 12.6356 15.201 12.6214 15.2239 12.6185ZM16.1466 11.0476C15.7525 11.0476 15.3757 11.0879 15.0381 11.1301C14.1915 11.2358 13.6096 11.966 13.534 12.7579C13.4982 13.1324 13.4657 13.5386 13.4657 13.9602C13.4657 14.3818 13.4982 14.788 13.534 15.1625C13.6096 15.9545 14.1915 16.6847 15.0381 16.7904C15.3757 16.8325 15.7525 16.8728 16.1466 16.8728C16.5407 16.8728 16.9176 16.8325 17.2552 16.7904C18.1018 16.6847 18.6837 15.9545 18.7593 15.1625C18.7951 14.788 18.8275 14.3818 18.8275 13.9602C18.8275 13.5386 18.7951 13.1324 18.7593 12.7579C18.6837 11.966 18.1018 11.2358 17.2552 11.1301C16.9176 11.0879 16.5407 11.0476 16.1466 11.0476Z"
        fill="url(#paint0_linear_113_1098)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_113_1098"
          x1="2.01709"
          y1="5.84204"
          x2="12.595"
          y2="21.6284"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.29" stopColor="#FFA267" />
          <stop offset="0.48" stopColor="#FF7154" />
        </linearGradient>
      </defs>
    </SvgIcon>
  )
}

export function ExpandMore() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
      />
      <path d="M0 0h24v24H0z" fill="none" />
    </SvgIcon>
  )
}

export function KeyboardArrowLeft() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
      />
      <path fill="none" d="M0 0h24v24H0V0z" />
    </SvgIcon>
  )
}

export function Info() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
      />
    </SvgIcon>
  )
}

export function Warning() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
      />
    </SvgIcon>
  )
}

export function ExpandLess() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
      />
      <path d="M0 0h24v24H0z" fill="none" />
    </SvgIcon>
  )
}

export function Blitz() {
  return (
    <SvgIcon
      viewBox="0 0 25 25"
      width="1em"
      height="1em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd" stroke="currentColor">
        <rect strokeWidth="3" x="1.5" y="1.5" width="22" height="22" rx="11" />
        <path
          fill="currentColor"
          d="M6.217 14.066l4.18.2-6.961 8.282 16.496-11.516-5.943.032 6.26-8.303z"
        />
      </g>
    </SvgIcon>
  )
}

export function PlayArrow() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M8 5v14l11-7z" fill="currentColor" />
      <path d="M0 0h24v24H0z" fill="none" />
    </SvgIcon>
  )
}

export function Spinner(props) {
  const [shouldRender, setShouldRender] = React.useState(false)

  React.useEffect(() => {
    if (props.delay) {
      // Use setTimeout to set shouldRender to true after 1000 milliseconds (1 second)
      const timer = setTimeout(() => {
        setShouldRender(true)
      }, 1000)

      // Clear the timer if the component unmounts
      return () => clearTimeout(timer)
    }
  }, [])

  if (props.delay && !shouldRender) {
    return null
  }

  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 44 44"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
    >
      <g fill="none" fillRule="evenodd" strokeWidth="2">
        <circle cx="22" cy="22" r="1">
          <animate
            attributeName="r"
            begin="0s"
            dur="1.8s"
            values="1; 20"
            calcMode="spline"
            keyTimes="0; 1"
            keySplines="0.165, 0.84, 0.44, 1"
            repeatCount="indefinite"
          />
          <animate
            attributeName="stroke-opacity"
            begin="0s"
            dur="1.8s"
            values="1; 0"
            calcMode="spline"
            keyTimes="0; 1"
            keySplines="0.3, 0.61, 0.355, 1"
            repeatCount="indefinite"
          />
        </circle>
        <circle cx="22" cy="22" r="1">
          <animate
            attributeName="r"
            begin="-0.9s"
            dur="1.8s"
            values="1; 20"
            calcMode="spline"
            keyTimes="0; 1"
            keySplines="0.165, 0.84, 0.44, 1"
            repeatCount="indefinite"
          />
          <animate
            attributeName="stroke-opacity"
            begin="-0.9s"
            dur="1.8s"
            values="1; 0"
            calcMode="spline"
            keyTimes="0; 1"
            keySplines="0.3, 0.61, 0.355, 1"
            repeatCount="indefinite"
          />
        </circle>
      </g>
    </SvgIcon>
  )
}

Spinner.propTypes = {
  delay: PropTypes.bool,
}

export function Roulette() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 15 15"
      width="1em"
      height="1em"
    >
      <g fill="none" fillRule="nonzero">
        <path
          fill="currentColor"
          d="M12.355 1.799a7.482 7.482 0 0 0-10.556.82 7.487 7.487 0 1 0 10.556-.82zm1.451 7.86l-2.288-.79c.308-.898.304-1.873 0-2.763l2.286-.787c.181.528.296 1.083.34 1.654a6.66 6.66 0 0 1-.338 2.686zm.129-4.403v-.001.001zm-1.413-2.151L10.7 4.687a4.24 4.24 0 0 0-2.393-1.382l.46-2.36a6.648 6.648 0 0 1 3.755 2.16zM5.215 1.21A6.59 6.59 0 0 1 6.21.94l.46 2.366a4.242 4.242 0 0 0-2.394 1.38L2.452 3.1a6.662 6.662 0 0 1 2.763-1.889zM1.168 5.315l2.288.789a4.276 4.276 0 0 0-.001 2.763l-2.288.788a6.718 6.718 0 0 1 0-4.34zm1.28 6.557l1.825-1.586a4.24 4.24 0 0 0 2.393 1.382l-.461 2.374a6.664 6.664 0 0 1-3.757-2.17zm7.31 1.897a6.678 6.678 0 0 1-.993.273l-.46-2.373a4.242 4.242 0 0 0 2.393-1.381l1.824 1.586a6.675 6.675 0 0 1-2.764 1.895z"
        />
        <g fill="currentColor" transform="translate(1 2)">
          <circle cx="3.716" cy=".702" r="1" />
          <circle cx=".957" cy="5.494" r="1" />
          <circle cx="3.728" cy="10.279" r="1" />
          <circle cx="9.258" cy="10.272" r="1" />
          <circle cx="12.016" cy="5.479" r="1" />
          <circle cx="9.245" cy=".694" r="1" />
        </g>
      </g>
    </svg>
  )
}

export function Done() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function Create() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function Language() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function Refresh() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
        fill="currentColor"
      />
      <path d="M0 0h24v24H0z" fill="none" />
    </SvgIcon>
  )
}

export function Notifications() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function NotificationsWettenlive() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.14062 5.625H10.8594V10H17.2656C17.4935 10 17.7121 9.90946 17.8733 9.74829C18.0345 9.58713 18.125 9.36854 18.125 9.14062V6.48437C18.125 6.25645 18.0345 6.03787 17.8733 5.8767C17.7121 5.71554 17.4935 5.625 17.2656 5.625H14.9289C15.2453 4.97328 15.319 4.2301 15.1368 3.52893C14.9545 2.82776 14.5282 2.21456 13.9344 1.79946C13.3406 1.38437 12.6183 1.19459 11.8972 1.26421C11.1761 1.33383 10.5034 1.65828 10 2.1793C9.49574 1.66114 8.82364 1.33919 8.10383 1.271C7.38402 1.2028 6.66342 1.39281 6.07082 1.80705C5.47822 2.22129 5.05225 2.83277 4.86903 3.5322C4.68581 4.23163 4.7573 4.97343 5.0707 5.625H2.73438C2.50645 5.625 2.28787 5.71554 2.12671 5.8767C1.96554 6.03787 1.875 6.25645 1.875 6.48437V9.14062C1.875 9.36854 1.96554 9.58713 2.12671 9.74829C2.20651 9.82809 2.30124 9.8914 2.40551 9.93458C2.50977 9.97777 2.62152 10 2.73438 10H9.14062V5.625ZM10.8594 4.29687C10.8594 4.0342 10.9373 3.77742 11.0832 3.55901C11.2291 3.3406 11.4366 3.17037 11.6792 3.06985C11.9219 2.96932 12.189 2.94302 12.4466 2.99427C12.7042 3.04551 12.9409 3.17201 13.1266 3.35775C13.3124 3.54349 13.4389 3.78014 13.4901 4.03777C13.5414 4.2954 13.515 4.56244 13.4145 4.80513C13.314 5.04781 13.1438 5.25523 12.9254 5.40117C12.707 5.54711 12.4502 5.625 12.1875 5.625H10.8594V4.29687ZM6.48438 4.29687C6.48438 3.94463 6.6243 3.60682 6.87337 3.35775C7.12245 3.10868 7.46026 2.96875 7.8125 2.96875C8.16474 2.96875 8.50255 3.10868 8.75163 3.35775C9.0007 3.60682 9.14062 3.94463 9.14062 4.29687V5.625H7.8125C7.46026 5.625 7.12245 5.48507 6.87337 5.236C6.6243 4.98693 6.48438 4.64911 6.48438 4.29687Z"
        fill="currentColor"
      />
      <path
        d="M10.8594 18.75H16.0156C16.2435 18.75 16.4621 18.6595 16.6233 18.4983C16.7845 18.3371 16.875 18.1185 16.875 17.8906V11.25H10.8594V18.75Z"
        fill="currentColor"
      />
      <path
        d="M3.125 17.8906C3.125 18.1185 3.21554 18.3371 3.37671 18.4983C3.53787 18.6595 3.75645 18.75 3.98438 18.75H9.14062V11.25H3.125V17.8906Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function NotificationsCasinosky() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2727 2.04545C19.2727 1.63124 18.9369 1.29545 18.5227 1.29545C18.1085 1.29545 17.7727 1.63124 17.7727 2.04545V2.57719L2.22727 7.90198V7.72727C2.22727 7.31306 1.89149 6.97727 1.47727 6.97727C1.06306 6.97727 0.727273 7.31306 0.727273 7.72727V12.2727C0.727273 12.6869 1.06306 13.0227 1.47727 13.0227C1.89149 13.0227 2.22727 12.6869 2.22727 12.2727V11.8716L4.05281 12.5011C4.12724 13.6238 4.52497 14.7026 5.20011 15.6064C5.91628 16.565 6.90993 17.2802 8.04635 17.655C9.18276 18.0298 10.4069 18.046 11.5529 17.7015C12.5828 17.3919 13.5047 16.8043 14.219 16.0067L17.7727 17.2321V17.9545C17.7727 18.3688 18.1085 18.7045 18.5227 18.7045C18.9369 18.7045 19.2727 18.3688 19.2727 17.9545V2.04545ZM12.6299 15.4587L5.64185 13.049C5.77381 13.6469 6.0317 14.2132 6.40181 14.7086C6.93382 15.4208 7.67196 15.9521 8.51615 16.2305C9.36034 16.5089 10.2697 16.5209 11.121 16.265C11.6755 16.0983 12.1879 15.8231 12.6299 15.4587Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function NotificationsPlayboomDisabled() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="7.5163"
        cy="14.3828"
        rx="3.73928"
        ry="3.68304"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M3.43867 12.1124L16.0301 16.0211C16.3044 16.1062 16.5977 16.1713 16.8703 16.0809C19.8602 15.09 19.8602 3.67735 16.8703 2.68643C16.5977 2.59608 16.3044 2.66116 16.0301 2.74631L3.43867 6.65499C0.758543 7.48697 0.758543 11.2804 3.43867 12.1124Z"
        fill="white"
        stroke="white"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}

export function NotificationsPlayboomDefault() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="7.5163"
        cy="14.3828"
        rx="3.73928"
        ry="3.68304"
        stroke="#9E8FA3"
        strokeWidth="1.5"
      />
      <path
        d="M3.43867 12.1124L16.0301 16.0211C16.3044 16.1062 16.5977 16.1713 16.8703 16.0809C19.8602 15.09 19.8602 3.67735 16.8703 2.68643C16.5977 2.59608 16.3044 2.66116 16.0301 2.74631L3.43867 6.65499C0.758543 7.48697 0.758543 11.2804 3.43867 12.1124Z"
        fill="#716377"
        stroke="#9E8FA3"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}

export function NotificationsPlayboomActive() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2524 3.46256C16.3737 3.4249 16.4621 3.40381 16.5329 3.39601C16.6001 3.38861 16.6275 3.39609 16.6343 3.39832C16.8002 3.45331 17.0082 3.60244 17.2327 3.9299C17.4557 4.25524 17.6614 4.70915 17.8347 5.27688C18.1809 6.41136 18.3626 7.88401 18.3626 9.38365C18.3626 10.8833 18.1809 12.3559 17.8347 13.4904C17.6614 14.0582 17.4557 14.5121 17.2327 14.8374C17.0082 15.1649 16.8002 15.314 16.6343 15.369C16.6275 15.3712 16.6001 15.3787 16.5329 15.3713C16.4621 15.3635 16.3737 15.3424 16.2524 15.3047L3.66091 11.3961C1.68432 10.7825 1.68432 7.98482 3.66091 7.37124L16.2524 3.46256ZM17.1062 1.97448C16.5884 1.80288 16.0898 1.94241 15.8077 2.02999L3.21621 5.93868C-0.167446 6.98904 -0.167447 11.7783 3.21621 12.8286L3.30204 12.8553C3.15868 13.2409 3.0698 13.6458 3.03914 14.0584C2.98849 14.7401 3.09815 15.4238 3.35923 16.0562C3.62029 16.6886 4.02545 17.2522 4.54234 17.7036C5.05918 18.1549 5.67389 18.4821 6.3384 18.6605C7.00289 18.839 7.69998 18.864 8.37575 18.7339C9.05154 18.6037 9.68857 18.3217 10.2372 17.909C10.7858 17.4962 11.2314 16.9636 11.5385 16.3519C11.6739 16.0822 11.7807 15.8005 11.8578 15.5112L15.8077 16.7373C16.0898 16.8249 16.5884 16.9644 17.1062 16.7928C17.6877 16.6001 18.1338 16.1758 18.4698 15.6856C18.8074 15.1933 19.0689 14.5853 19.2694 13.9282C19.6707 12.6132 19.8626 10.9849 19.8626 9.38365C19.8626 7.7824 19.6707 6.15415 19.2694 4.83909C19.0689 4.18205 18.8074 3.57403 18.4698 3.0817C18.1338 2.5915 17.6877 2.16722 17.1062 1.97448ZM10.4234 15.0659L4.73789 13.301C4.62582 13.5781 4.5572 13.871 4.53501 14.1696C4.50173 14.6175 4.57371 15.0672 4.74574 15.4839C4.91778 15.9007 5.18551 16.2738 5.529 16.5738C5.87254 16.8738 6.28253 17.0924 6.72739 17.2119C7.17228 17.3313 7.63936 17.3481 8.09208 17.261C8.54479 17.1738 8.97017 16.9851 9.33533 16.7103C9.70046 16.4356 9.99535 16.0824 10.198 15.6789C10.2965 15.4827 10.3719 15.2771 10.4234 15.0659Z"
        fill="url(#paint0_linear_113_1158)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_113_1158"
          x1="1.62595"
          y1="4.16991"
          x2="16.5176"
          y2="22.3284"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.29" stopColor="#FFA267" />
          <stop offset="0.48" stopColor="#FF7154" />
        </linearGradient>
      </defs>
    </SvgIcon>
  )
}

export function Person() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function AllInclusive() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M18.6 6.62c-1.44 0-2.8.56-3.77 1.53L12 10.66 10.48 12h.01L7.8 14.39c-.64.64-1.49.99-2.4.99-1.87 0-3.39-1.51-3.39-3.38S3.53 8.62 5.4 8.62c.91 0 1.76.35 2.44 1.03l1.13 1 1.51-1.34L9.22 8.2A5.37 5.37 0 005.4 6.62C2.42 6.62 0 9.04 0 12s2.42 5.38 5.4 5.38c1.44 0 2.8-.56 3.77-1.53l2.83-2.5.01.01L13.52 12h-.01l2.69-2.39c.64-.64 1.49-.99 2.4-.99 1.87 0 3.39 1.51 3.39 3.38s-1.52 3.38-3.39 3.38c-.9 0-1.76-.35-2.44-1.03l-1.14-1.01-1.51 1.34 1.27 1.12a5.386 5.386 0 003.82 1.57c2.98 0 5.4-2.41 5.4-5.38s-2.42-5.37-5.4-5.37z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function Article() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function Favorite() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function Casino() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M19.592 6.8H22.8A1.2 1.2 0 0124 8v12a1.2 1.2 0 01-1.2 1.2H1.2A1.2 1.2 0 010 20V8a1.2 1.2 0 011.2-1.2h3.208A8.4 8.4 0 0112 2a8.4 8.4 0 017.592 4.8zM2.4 9.2h4.8v9.6H2.4zm12 9.6V9.2H9.6v9.6zm2.4-9.6h4.8v9.6h-4.8z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </SvgIcon>
  )
}

export function LiveCasino() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M20.485 20.485c-4.686 4.687-12.284 4.687-16.97 0-4.687-4.686-4.687-12.284 0-16.97 4.686-4.687 12.284-4.687 16.97 0 4.687 4.686 4.687 12.284 0 16.97zm-16.07-2.598l1.716-1.715A7.16 7.16 0 014.9 13.2H2.474a9.553 9.553 0 001.94 4.687h.001zM2.476 10.8H4.9a7.162 7.162 0 011.23-2.972L4.417 6.113A9.553 9.553 0 002.475 10.8h.001zm3.638-6.384L7.828 6.13A7.161 7.161 0 0110.8 4.9V2.474a9.553 9.553 0 00-4.687 1.94l.001.002zm10.06 1.715A7.161 7.161 0 0013.2 4.9V2.474a9.553 9.553 0 014.687 1.94L16.172 6.13l.002.001zM13.2 21.525a9.552 9.552 0 004.687-1.94l-1.715-1.716A7.16 7.16 0 0113.2 19.1v2.426-.001zm-2.4 0V19.1a7.162 7.162 0 01-2.972-1.23l-1.715 1.714a9.554 9.554 0 004.687 1.941zm8.784-15.412a9.554 9.554 0 011.941 4.687H19.1a7.162 7.162 0 00-1.23-2.972l1.714-1.715zM19.1 13.2h2.425a9.552 9.552 0 01-1.94 4.687l-1.716-1.715A7.161 7.161 0 0019.1 13.2zm-3.706 2.194a4.8 4.8 0 11-6.788-6.788 4.8 4.8 0 016.788 6.788z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </SvgIcon>
  )
}

export function Store() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        d="M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </SvgIcon>
  )
}

export function Faq() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        d="M11.5 2C6.81 2 3 5.81 3 10.5S6.81 19 11.5 19h.5v3c4.86-2.34 8-7 8-11.5C20 5.81 16.19 2 11.5 2zm1 14.5h-2v-2h2v2zm0-3.5h-2c0-3.25 3-3 3-5 0-1.1-.9-2-2-2s-2 .9-2 2h-2c0-2.21 1.79-4 4-4s4 1.79 4 4c0 2.5-3 2.75-3 5z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </SvgIcon>
  )
}

export function Wallet() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 64 64"
    >
      <g fill="currentColor">
        <path
          d="M10.1825 32.2013V25.455C10.1825 23.1674 11.9569 21.307 14.1987 21.1266L20.4639 10.1836C21.0445 9.17151 21.982 8.44815 23.1038 8.14778C24.2203 7.84945 25.3878 8.00613 26.3871 8.58775L47.8643 21.0914H51.6364C54.0429 21.0914 56 23.0484 56 25.455V51.6364C56 54.0429 54.043 56 51.6364 56H14.5461C12.1395 56 10.1825 54.043 10.1825 51.6364V44.8901C8.91542 44.4383 8.00071 43.2387 8.00071 41.8184V35.273C8.00071 33.8527 8.91542 32.6532 10.1825 32.2013ZM16.7339 21.0914H26.2422L19.1109 16.9396L16.7339 21.0914ZM20.1949 15.0463L30.5784 21.0914H34.8853L21.2718 13.1654L20.1949 15.0463ZM25.2888 10.4733C24.7956 10.1846 24.2193 10.1079 23.6684 10.255C23.1113 10.4041 22.6467 10.7642 22.358 11.2681L22.3558 11.2721L39.2213 21.0914H43.528L25.2888 10.4733ZM12.3643 51.6364C12.3643 52.8391 13.3433 53.8181 14.5461 53.8181H51.6364C52.8391 53.8181 53.8181 52.8391 53.8181 51.6364V25.455C53.8181 24.2523 52.8391 23.2733 51.6364 23.2733H14.5461C13.3433 23.2733 12.3643 24.2523 12.3643 25.455V32.0004H18.9097C22.519 32.0004 25.455 34.9364 25.455 38.5457C25.455 42.1551 22.519 45.0911 18.9097 45.0911H12.3643V51.6364ZM10.1825 41.8184C10.1825 42.4202 10.6714 42.9093 11.2734 42.9093H18.9097C21.3162 42.9093 23.2733 40.9523 23.2733 38.5457C23.2733 36.1392 21.3163 34.1821 18.9097 34.1821H11.2734C10.6715 34.1821 10.1825 34.6711 10.1825 35.273V41.8184Z"
          fill="currentColor"
        />
        <path
          d="M18.91 36.3633C20.1128 36.3633 21.0918 37.3423 21.0918 38.545C21.0918 39.7477 20.1128 40.7268 18.91 40.7268C17.7073 40.7268 16.7283 39.7477 16.7283 38.545C16.7282 37.3423 17.7072 36.3633 18.91 36.3633Z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  )
}

export function Ball() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.8612 10.0021C18.8441 13.5915 16.6186 16.9468 13.2461 18.2536C11.3972 18.9669 9.35428 19.0582 7.45405 18.4933C5.78777 17.9968 4.3041 16.9982 3.18564 15.6743C0.823187 12.8724 0.497921 8.73529 2.32968 5.57394C4.22992 2.29845 8.1274 0.540876 11.8423 1.33977C15.4145 2.11014 18.1821 5.04895 18.7585 8.6554C18.8326 9.0948 18.8555 9.55131 18.8612 10.0021C18.8669 10.7382 20.0082 10.7382 20.0025 10.0021C19.9796 5.88208 17.4175 2.1615 13.5827 0.666417C9.59966 -0.885728 4.86904 0.398216 2.20985 3.74218C0.920196 5.36851 0.14983 7.33722 0.0185823 9.41436C-0.106959 11.4344 0.406619 13.4944 1.46801 15.2235C3.6821 18.8299 8.01898 20.6674 12.1561 19.7772C16.0936 18.927 19.2549 15.6058 19.8712 11.617C19.9511 11.0863 20.0025 10.5499 20.0025 10.0078C20.0082 9.26599 18.8669 9.26599 18.8612 10.0021Z"
        fill="currentColor"
      />
      <path
        d="M8.08778 12.6855L6.91797 9.08479L9.98231 6.86499L13.0467 9.08479L11.8768 12.6855H8.08778Z"
        fill="currentColor"
      />
      <path
        d="M8.64105 12.5027C8.25302 11.31 7.85927 10.1117 7.47124 8.91904C7.38564 9.13588 7.29434 9.34702 7.20874 9.56387C8.23019 8.82203 9.25164 8.0859 10.2731 7.34407C10.0791 7.34407 9.89076 7.34407 9.69674 7.34407C10.7182 8.0802 11.7396 8.82203 12.7611 9.55816C12.6755 9.34131 12.5842 9.13018 12.4986 8.91333C12.1106 10.1117 11.7168 11.3043 11.3288 12.5027C11.5114 12.3657 11.694 12.2231 11.8766 12.0861C10.6155 12.0861 9.35436 12.0861 8.08753 12.0861C7.3514 12.0861 7.3514 13.2274 8.08753 13.2274C9.34865 13.2274 10.6098 13.2274 11.8766 13.2274C12.1391 13.2274 12.3502 13.0505 12.4244 12.8108C12.8124 11.6125 13.2062 10.4198 13.5942 9.22148C13.6798 8.96469 13.5315 8.71932 13.3317 8.57666C12.3103 7.84053 11.2888 7.09869 10.2674 6.36257C10.119 6.25414 9.8394 6.25414 9.69103 6.36257C8.66958 7.1044 7.64814 7.84053 6.62669 8.58236C6.42696 8.72502 6.2786 8.9704 6.36419 9.22719C6.75223 10.4198 7.14597 11.6182 7.53401 12.8108C7.76797 13.5013 8.86931 13.2046 8.64105 12.5027Z"
        fill="currentColor"
      />
      <path
        d="M13.1032 1.14144L10.0388 3.35553L6.97449 1.13574L7.00302 1.05585C7.94458 0.741993 8.95461 0.570801 10.0046 0.570801C11.0831 0.570801 12.1217 0.753406 13.0861 1.08438L13.1032 1.14144Z"
        fill="currentColor"
      />
      <path
        d="M12.8124 0.650532C11.7909 1.38666 10.7695 2.1285 9.74804 2.86462C9.94206 2.86462 10.1304 2.86462 10.3244 2.86462C9.30294 2.12279 8.28149 1.38666 7.26004 0.644826C7.34564 0.86167 7.43694 1.07281 7.52254 1.28965C7.53395 1.26112 7.53966 1.23829 7.55107 1.20976C7.41982 1.34101 7.28287 1.47796 7.15162 1.60921C9.04044 0.987211 11.0491 0.998624 12.9322 1.63774C12.801 1.5065 12.664 1.36954 12.5328 1.23829C12.5385 1.25541 12.5442 1.27253 12.5499 1.28965C12.7782 1.98583 13.8795 1.6891 13.6512 0.987211C13.5371 0.633413 13.2746 0.54211 12.9436 0.439395C12.6298 0.342385 12.3159 0.262495 11.9907 0.199725C11.3344 0.068477 10.6668 0 9.99912 0C9.34859 0 8.69235 0.0684771 8.04753 0.194018C7.72226 0.256789 7.4027 0.336679 7.08885 0.433688C6.75788 0.536404 6.53533 0.644826 6.4212 0.987211C6.3356 1.244 6.48397 1.48938 6.68369 1.63204C7.70514 2.37387 8.72659 3.11 9.74804 3.85183C9.89641 3.96026 10.176 3.96026 10.3244 3.85183C11.3458 3.11571 12.3673 2.37387 13.3887 1.63774C13.6398 1.45514 13.7597 1.14128 13.5942 0.855963C13.4515 0.610587 13.0635 0.467927 12.8124 0.650532Z"
        fill="currentColor"
      />
      <path
        d="M3.70469 7.95485L0.651759 10.1803L0.571869 10.1233C0.571869 10.0833 0.571869 10.0377 0.571869 9.99774C0.571869 7.88066 1.26805 5.94619 2.44928 4.34839H2.552L3.70469 7.95485Z"
        fill="currentColor"
      />
      <path
        d="M3.41961 7.46415C2.40386 8.20598 1.38242 8.94782 0.366673 9.68965C0.560691 9.68965 0.749003 9.68965 0.943021 9.68965C0.914489 9.67253 0.891663 9.64971 0.863131 9.63259C0.96014 9.79807 1.05144 9.96356 1.14845 10.1233C1.13133 8.13751 1.76475 6.23727 2.94597 4.64518C2.78049 4.74219 2.615 4.83349 2.45522 4.9305C2.48946 4.9305 2.5237 4.9305 2.55794 4.9305C2.37533 4.79355 2.19273 4.65089 2.01012 4.51393C2.39816 5.71228 2.78049 6.91063 3.16853 8.10898C3.39108 8.80516 4.49241 8.50842 4.26986 7.80653C3.88183 6.60819 3.4995 5.40984 3.11146 4.21149C3.03157 3.97182 2.82043 3.79492 2.56364 3.79492C2.18131 3.79492 2.01012 4.01177 1.80469 4.30279C1.61638 4.56529 1.44519 4.8392 1.28541 5.12452C0.965847 5.69516 0.703352 6.30004 0.49792 6.92204C0.292489 7.54404 0.161242 8.18887 0.0813516 8.8394C0.0414067 9.18178 0.0185812 9.51846 0.0128748 9.86085C0.0128748 10.0263 -0.00424476 10.1975 0.0585259 10.3516C0.121296 10.5057 0.241131 10.5913 0.372379 10.6826C0.520746 10.791 0.80036 10.791 0.948727 10.6826C1.96447 9.94074 2.98592 9.1989 4.00166 8.45707C4.25274 8.27446 4.37258 7.96061 4.20709 7.67529C4.05873 7.4242 3.67069 7.28154 3.41961 7.46415Z"
        fill="currentColor"
      />
      <path
        d="M7.3 18.991L7.25435 19.0252C5.23999 18.4146 3.51094 17.1478 2.3183 15.4701L2.34683 15.3845L6.12448 15.3959L7.3 18.991Z"
        fill="currentColor"
      />
      <path
        d="M7.01455 18.5002C6.99743 18.5116 6.98602 18.5231 6.9689 18.5345C7.11726 18.5173 7.25992 18.4945 7.40829 18.4774C5.57082 17.9068 3.93879 16.7484 2.81462 15.1848C2.83174 15.3332 2.85457 15.4758 2.87169 15.6242C2.8831 15.5957 2.88881 15.5671 2.90022 15.5386C2.71761 15.6755 2.53501 15.8182 2.3524 15.9552C3.61352 15.9609 4.86893 15.9609 6.13005 15.9666C5.94745 15.8296 5.76484 15.687 5.58224 15.55C5.97598 16.7484 6.36402 17.9467 6.75776 19.1451C6.98602 19.8412 8.08735 19.5445 7.8591 18.8426C7.46535 17.6443 7.07732 16.4459 6.68358 15.2476C6.60369 15.0079 6.39255 14.831 6.13576 14.831C4.87464 14.8253 3.61923 14.8253 2.35811 14.8196C2.09561 14.8196 1.88448 14.9965 1.81029 15.2362C1.69617 15.5957 1.89018 15.8353 2.09561 16.1035C2.29534 16.3603 2.50077 16.6057 2.71761 16.8397C3.1456 17.3019 3.62493 17.7127 4.13281 18.0837C4.62356 18.4489 5.15426 18.7627 5.70778 19.0252C5.99881 19.1622 6.29554 19.2877 6.59798 19.3961C6.91183 19.5103 7.29416 19.7043 7.60231 19.4817C7.85339 19.2991 7.97323 18.9853 7.80774 18.7C7.64796 18.4603 7.26563 18.3176 7.01455 18.5002Z"
        fill="currentColor"
      />
      <path
        d="M17.7368 15.4014C16.5499 17.0962 14.8208 18.3858 12.8007 19.0135L12.7722 18.9964L13.9477 15.4071L17.7311 15.4014H17.7368Z"
        fill="currentColor"
      />
      <path
        d="M17.2405 15.1106C16.1221 16.6912 14.4958 17.8782 12.6469 18.4602C12.7952 18.4774 12.9379 18.5002 13.0863 18.5173C13.0749 18.5116 13.0692 18.5059 13.0577 18.5002C13.1433 18.717 13.2346 18.9282 13.3202 19.145C13.714 17.9467 14.1077 16.7483 14.4958 15.5557C14.3132 15.6926 14.1305 15.8353 13.9479 15.9722C15.2091 15.9722 16.4702 15.9665 17.7313 15.9665C17.5487 15.8296 17.3661 15.6869 17.1835 15.55V15.5557C17.4003 16.2576 18.5017 15.9551 18.2848 15.2532V15.2475C18.2106 15.0078 17.9881 14.8309 17.737 14.8309C16.4759 14.8309 15.2148 14.8367 13.9536 14.8367C13.6912 14.8367 13.48 15.0136 13.4058 15.2532C13.0121 16.4516 12.6183 17.6499 12.2303 18.8426C12.1447 19.0994 12.2931 19.339 12.4928 19.4874C12.7667 19.6871 13.1091 19.5216 13.3887 19.4189C13.674 19.3162 13.9536 19.1964 14.2333 19.0708C14.7583 18.8311 15.2604 18.5401 15.7341 18.2034C16.7098 17.513 17.5487 16.6684 18.2392 15.6869C18.4161 15.4358 18.2848 15.0535 18.0337 14.9051C17.737 14.7396 17.4232 14.8595 17.2405 15.1106Z"
        fill="currentColor"
      />
      <path
        d="M19.4317 10.0034C19.4317 10.0604 19.4317 10.1232 19.4317 10.1803L19.4259 10.186L16.373 7.95475L17.5371 4.354H17.5599C18.7355 5.9518 19.4317 7.88628 19.4317 10.0034Z"
        fill="currentColor"
      />
      <path
        d="M18.8612 10.0036C18.8612 10.0607 18.8612 10.1234 18.8612 10.1805C18.9582 10.015 19.0495 9.84952 19.1465 9.68974L19.1408 9.69545C19.3348 9.69545 19.5231 9.69545 19.7172 9.69545C18.7014 8.95362 17.6857 8.20608 16.6642 7.46424C16.7498 7.68108 16.8411 7.89222 16.9267 8.10907C17.3148 6.91072 17.7028 5.71237 18.0908 4.50832C17.9082 4.64527 17.7256 4.78793 17.543 4.92488C17.5487 4.92488 17.5601 4.92488 17.5658 4.92488C17.4003 4.82787 17.2349 4.73657 17.0751 4.63956C18.2221 6.20883 18.8498 8.05771 18.8612 10.0036C18.8669 10.7397 20.0082 10.7397 20.0025 10.0036C19.9968 8.83378 19.8028 7.65826 19.3919 6.55692C19.1979 6.03193 18.9639 5.51835 18.6843 5.03331C18.5473 4.79364 18.399 4.55967 18.2392 4.33142C18.0566 4.06892 17.8911 3.78931 17.5373 3.78931C17.2748 3.78931 17.0637 3.9662 16.9895 4.20587C16.6014 5.40422 16.2134 6.60257 15.8254 7.80663C15.7398 8.06341 15.8881 8.30308 16.0879 8.45145C17.1036 9.19329 18.1194 9.94083 19.1408 10.6827C19.2892 10.7911 19.5688 10.7911 19.7172 10.6827C19.9682 10.5001 20.0082 10.3003 20.0082 10.0093C20.0082 9.26747 18.8669 9.26747 18.8612 10.0036Z"
        fill="currentColor"
      />
      <path
        d="M9.41138 3.44101C9.41138 4.52523 9.41138 5.60945 9.41138 6.69367C9.41138 7.4298 10.5527 7.4298 10.5527 6.69367C10.5527 5.60945 10.5527 4.52523 10.5527 3.44101C10.5527 2.70488 9.41138 2.70488 9.41138 3.44101Z"
        fill="currentColor"
      />
      <path
        d="M16.219 7.40668C15.112 7.7776 14.0049 8.14852 12.8922 8.51943C12.2017 8.7534 12.4984 9.85474 13.1946 9.62077C14.3017 9.24986 15.4087 8.87894 16.5215 8.50802C17.2176 8.27406 16.9152 7.17272 16.219 7.40668Z"
        fill="currentColor"
      />
      <path
        d="M14.4444 15.1108C13.754 14.1977 13.0578 13.2847 12.3673 12.366C12.179 12.1206 11.8766 11.9951 11.5855 12.1606C11.3459 12.3032 11.1918 12.6913 11.3801 12.9423C12.0706 13.8554 12.7668 14.7684 13.4572 15.6871C13.6455 15.9325 13.948 16.058 14.239 15.8926C14.4787 15.7499 14.6328 15.3561 14.4444 15.1108Z"
        fill="currentColor"
      />
      <path
        d="M6.61514 15.6871C7.27138 14.774 7.92191 13.861 8.57815 12.9423C8.75505 12.6912 8.6238 12.3089 8.37272 12.1605C8.0874 11.995 7.77355 12.1148 7.59094 12.3659C6.9347 13.279 6.28417 14.192 5.62793 15.1107C5.45104 15.3618 5.58228 15.7441 5.83337 15.8925C6.12439 16.058 6.43825 15.9381 6.61514 15.6871Z"
        fill="currentColor"
      />
      <path
        d="M3.55653 8.50836C4.62934 8.87928 5.69644 9.25019 6.76924 9.62682C7.06027 9.72953 7.39124 9.51269 7.47113 9.22737C7.55673 8.91352 7.36271 8.6282 7.07168 8.52548C5.99888 8.15456 4.93178 7.78364 3.85897 7.40702C3.56794 7.30431 3.23697 7.52115 3.15708 7.80647C3.07148 8.12032 3.2655 8.40564 3.55653 8.50836Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function BallWettenlive() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 1.875C5.51992 1.875 1.875 5.51992 1.875 10C1.875 14.4801 5.51992 18.125 10 18.125C14.4801 18.125 18.125 14.4801 18.125 10C18.125 5.51992 14.4801 1.875 10 1.875ZM15.4938 13.4406H13.6668L13.007 12.3078L13.593 9.94687L14.7574 9.45312L16.4234 10.8871C16.2987 11.7947 15.9817 12.6653 15.4938 13.4406ZM5.24258 9.45312L6.40625 9.94805L6.99219 12.309L6.33242 13.4418H4.50625C4.01841 12.6668 3.70147 11.7967 3.57656 10.8895L5.24258 9.45312ZM14.9719 5.84102L14.2527 7.88516L13.0371 8.4L10.8203 6.54141V5.17422L12.5336 4.03281C13.4775 4.4356 14.3129 5.05554 14.9719 5.84219V5.84102ZM7.46641 4.03125L9.17969 5.17266V6.53984L6.96289 8.39961L5.74727 7.88477L5.02813 5.84063C5.68713 5.05398 6.52255 4.43403 7.46641 4.03125ZM8.49922 16.3086L7.71406 14.3297L8.33906 13.2551H11.6594L12.2867 14.3305L11.5055 16.307C10.5167 16.5424 9.48644 16.5424 8.49766 16.307L8.49922 16.3086Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function BallCasinosky() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 1C5.03745 1 1 5.03745 1 10C1 14.9625 5.03745 19 10 19C14.9625 19 19 14.9625 19 10C19 5.03745 14.9625 1 10 1ZM16.0854 13.8112H14.0617L13.3309 12.5563L13.9799 9.94115L15.2698 9.39423L17.1152 10.9826C16.977 11.988 16.6259 12.9523 16.0854 13.8112ZM4.73024 9.39423L6.01923 9.94245L6.66827 12.5576L5.93745 13.8125H3.91462C3.37424 12.954 3.02317 11.9901 2.88481 10.9852L4.73024 9.39423ZM15.5073 5.39313L14.7107 7.6574L13.3642 8.22769L10.9087 6.16894V4.65452L12.8064 3.39019C13.8519 3.83635 14.7773 4.52306 15.5073 5.39442V5.39313ZM7.19356 3.38846L9.09135 4.65279V6.16721L6.63582 8.22726L5.28928 7.65697L4.49269 5.39269C5.22266 4.52133 6.14805 3.83462 7.19356 3.38846ZM8.3376 16.988L7.46788 14.796L8.16019 13.6056H11.8381L12.533 14.7968L11.6676 16.9862C10.5723 17.247 9.43114 17.247 8.33587 16.9862L8.3376 16.988Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function BallPlayboomDisabled() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1937 1.55258C10.4213 1.11569 8.45406 1.41407 6.37324 2.4695L10.2724 9.22306L12.7407 7.81447C11.6778 5.67156 11.4794 3.53839 12.1937 1.55258ZM5.07424 3.21956C3.12532 4.49055 1.88498 6.04019 1.37485 7.7878C3.44769 8.15712 5.19384 9.38608 6.51892 11.3651L8.96961 9.96655L5.07424 3.21956ZM1.12047 9.26626C1.03655 10.6955 1.39198 12.2297 2.19676 13.8317L5.2125 12.1107C4.09251 10.4763 2.70113 9.55125 1.12047 9.26626ZM2.94207 15.1334C3.93902 16.675 5.10886 17.778 6.41228 18.4318C6.9617 16.904 6.84796 15.2166 5.96667 13.4073L2.94207 15.1334ZM7.81986 18.9507C9.58837 19.3827 11.5505 19.0834 13.6257 18.0311L9.71962 11.2656L7.2717 12.6626C8.34244 14.8147 8.54139 16.9572 7.81986 18.9507ZM14.9247 17.2811C16.8792 16.0068 18.1212 14.4523 18.629 12.699C16.5586 12.3258 14.8148 11.0939 13.4919 9.11282L11.0224 10.5221L14.9247 17.2811ZM18.8803 11.22C18.9614 9.79097 18.6036 8.25725 17.797 6.65595L14.7982 8.36734C15.9154 10.0027 17.3033 10.9306 18.8803 11.22ZM17.0504 5.35496L14.0458 7.06965C13.1733 5.27176 13.0589 3.59437 13.6002 2.07446C14.8954 2.72738 16.0583 3.82433 17.0504 5.35496Z"
        fill="white"
      />
    </SvgIcon>
  )
}

export function BallPlayboomDefault() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5198 18.0912C20.5229 15.2027 21.7124 10.7636 18.8238 5.7605C15.9353 0.757382 11.4962 -0.432063 6.49307 2.45649C1.48995 5.34504 0.300501 9.78411 3.18906 14.7872C6.07761 19.7904 10.5167 20.9798 15.5198 18.0912Z"
        fill="#716377"
        stroke="#9E8FA3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.48329 2.44097L15.5282 18.1073"
        stroke="#9E8FA3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.73846 8.47908C4.00324 8.7061 5.9042 10.0306 7.28507 12.4224C8.66595 14.8141 8.86253 17.1226 7.92675 19.1975"
        stroke="#9E8FA3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1044 1.33952C13.1686 3.41438 13.3652 5.72291 14.7461 8.11467C16.127 10.5064 18.0279 11.8309 20.2927 12.0579"
        stroke="#9E8FA3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.19839 14.8602L18.8114 5.89649"
        stroke="#9E8FA3"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </SvgIcon>
  )
}

export function BallPlayboomActive() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.68263 15.4049C4.00761 17.6083 5.67085 19.1369 7.61181 19.8782L7.61846 19.8812C7.65178 19.8962 7.68562 19.9086 7.71975 19.9185C7.93239 19.9961 8.14831 20.0643 8.36745 20.1231C10.6638 20.7384 13.178 20.2722 15.7481 18.8245C15.8012 18.8082 15.8532 18.7857 15.9034 18.7567C15.9535 18.7278 15.9989 18.694 16.0396 18.6562C18.5791 17.1542 20.2403 15.2097 20.8557 12.9129C20.9058 12.7262 20.9487 12.5379 20.9845 12.3484C21.0126 12.2813 21.0314 12.2089 21.039 12.1327C21.0433 12.09 21.0439 12.0478 21.0411 12.0064C21.3396 9.917 20.7936 7.67213 19.4734 5.38549C18.1534 3.09907 16.4824 1.5039 14.524 0.7176C14.4893 0.694278 14.4522 0.673546 14.4128 0.655792C14.3428 0.624186 14.2704 0.604235 14.1979 0.595114C14.0162 0.531465 13.8321 0.474619 13.6456 0.424663C11.3492 -0.190658 8.83501 0.27553 6.26489 1.72328C6.2114 1.73962 6.15891 1.76223 6.1084 1.7914C6.05788 1.82057 6.01203 1.85473 5.97112 1.89291C3.43296 3.39472 1.77256 5.33873 1.15734 7.63477C1.09863 7.85386 1.04977 8.07494 1.01067 8.29785C1.00212 8.33237 0.995921 8.36791 0.992271 8.40432L0.991565 8.41173C0.657077 10.501 1.17366 12.7491 2.47045 15.0412C2.48687 15.1071 2.51258 15.1718 2.54807 15.2336C2.58536 15.2986 2.63091 15.3559 2.68263 15.4049ZM4.26928 15.1103L7.02077 13.5306C7.80922 15.1984 7.94379 16.7616 7.5069 18.1904C6.32437 17.5824 5.23012 16.5667 4.26928 15.1103ZM8.32499 12.7818C9.30922 14.8085 9.51942 16.8249 8.91488 18.7145C10.5569 19.1078 12.4305 18.8417 14.4848 17.7998L10.7755 11.375L8.32499 12.7818ZM10.0255 10.0759L7.58404 11.4776C6.3093 9.53398 4.63609 8.2963 2.65086 7.86493C3.1313 6.24632 4.2986 4.75674 6.22804 3.49861L10.0255 10.0759ZM12.0763 10.6281L15.7839 17.0498C17.7195 15.788 18.8883 14.2933 19.3663 12.669C17.4388 12.2461 15.806 11.0622 14.5474 9.20942L12.0763 10.6281ZM13.7864 7.9167L11.3263 9.32907L7.52704 2.74855C9.58756 1.70324 11.4664 1.43838 13.112 1.83648C12.497 3.77226 12.7364 5.8407 13.7864 7.9167ZM15.8523 8.46025C16.8956 9.9585 18.1709 10.8489 19.613 11.1866C19.674 9.87266 19.3467 8.43434 18.5815 6.89335L15.8523 8.46025ZM17.8419 5.58837L15.0892 7.16874C14.2348 5.44674 14.0746 3.83439 14.5191 2.36402C15.7371 2.99365 16.8611 4.05633 17.8419 5.58837ZM6.28071 12.2258L3.51271 13.815C2.68649 12.2074 2.33436 10.7098 2.40081 9.34636C3.8973 9.69178 5.21484 10.6312 6.28071 12.2258Z"
        fill="url(#paint0_linear_113_1131)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_113_1131"
          x1="1.89147"
          y1="2.88133"
          x2="19.9949"
          y2="22.3541"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.29" stopColor="#FFA267" />
          <stop offset="0.48" stopColor="#FF7154" />
        </linearGradient>
      </defs>
    </SvgIcon>
  )
}

export function Bolt() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 -960 960 960"
    >
      <path
        d="m286-79 171-307-337-40 495-455h59L503-574l337 40L345-79h-59Zm167-187 252-223-297-36 99-169-253 224 297 35-98 169Zm27-214Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function Moments() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 20"
    >
      <path
        d="M18.9202 2.67794C18.1383 1.91273 17.2566 1.5433 16.3337 1.5896C16.2736 1.59217 16.2113 1.59677 16.1452 1.6043V0.526972C16.1452 0.236368 15.902 0 15.6031 0L4.39737 0.00018381C4.09853 0.00018381 3.85527 0.236562 3.85527 0.527156V1.60411C3.79002 1.59694 3.72844 1.59216 3.66763 1.58959C2.72803 1.54529 1.8599 1.91475 1.08018 2.67793C0.0309681 3.70449 -0.27658 5.24372 0.257416 6.79452C0.912247 8.69748 2.57715 10.1935 4.71708 10.8056C5.50975 12.1079 6.80108 13.0878 8.27986 13.5107V15.0475H6.603C6.45937 15.0475 6.3196 15.1045 6.21824 15.2032L4.87285 16.5202C4.84235 16.55 4.81493 16.5853 4.78521 16.6356C4.78405 16.6373 4.77227 16.6599 4.77131 16.6614C4.74833 16.7077 4.73366 16.7481 4.72459 16.7963C4.7188 16.8274 4.71494 16.8593 4.71494 16.8919V18.473C4.71494 18.7636 4.95818 19 5.25704 19H14.7424C15.0413 19 15.2845 18.7636 15.2845 18.473L15.2832 16.963C15.2869 16.9395 15.2898 16.9163 15.2898 16.8919C15.2898 16.7259 15.212 16.573 15.0905 16.4848L13.7809 15.2031C13.6799 15.1042 13.5398 15.0474 13.3961 15.0474H11.7193L11.7194 13.5107C13.1982 13.0882 14.4896 12.1081 15.2824 10.8056C17.4218 10.1937 19.0867 8.69787 19.7423 6.79453C20.2766 5.24373 19.9693 3.70488 18.9201 2.67795L18.9202 2.67794ZM18.2045 6.29202C17.8682 7.26861 17.0748 8.17734 16.0541 8.76793C16.1147 8.4266 16.1453 8.08233 16.1453 7.74081V3.20308C16.2346 3.18378 16.3203 3.17275 16.4051 3.16907L16.4671 3.16779C16.914 3.16779 17.34 3.37218 17.77 3.7931C18.3852 4.39546 18.5437 5.30621 18.2045 6.29197L18.2045 6.29202ZM2.23063 3.79348C2.66132 3.37219 3.08294 3.16741 3.52003 3.16741C3.54281 3.16741 3.56578 3.16796 3.58972 3.16925C3.67582 3.17274 3.76327 3.18395 3.85536 3.20344V7.74117C3.85536 8.08324 3.88586 8.42733 3.94667 8.7681C2.92603 8.17789 2.13217 7.26897 1.79626 6.29219C1.45707 5.30681 1.61537 4.39601 2.23063 3.79346V3.79348Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function MomentsPlayboomDisabled() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.51437 9.21891C4.58926 12.2183 6.99433 14.8431 9.99466 14.8431C13.0421 14.8431 15.3898 12.2606 15.4734 9.21436C15.4837 8.83973 15.4892 8.46236 15.4892 8.08226C15.4892 6.34226 15.3866 4.64 15.2114 3.0235C15.1355 2.32385 14.6086 1.75709 13.9138 1.64502C12.6459 1.44052 11.3455 1.32144 9.99466 1.32144C8.63987 1.32144 7.31578 1.43372 6.05043 1.6416C5.36757 1.75378 4.85157 2.31124 4.77498 2.99899C4.59449 4.6196 4.50015 6.33458 4.50015 8.08226C4.50015 8.464 4.50498 8.84286 4.51437 9.21891Z"
        fill="white"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M9.99466 14.8538V19.1786"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.56059 19.1786H13.4287"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1458 2.69507H17.2732C18.1845 2.69507 18.9232 3.4338 18.9232 4.34507V4.37591C18.9232 5.71327 18.4891 6.99586 17.7163 7.94152C17.1065 8.68767 16.3253 9.17583 15.4859 9.3486"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.80602 2.69507H2.72683C1.81556 2.69507 1.07683 3.4338 1.07683 4.34507V4.37591C1.07683 5.71327 1.511 6.99586 2.28381 7.94152C2.89022 8.68355 3.66616 9.17044 4.50024 9.34571"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}

export function MomentsPlayboomDefault() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="7.5163"
        cy="14.3828"
        rx="3.73928"
        ry="3.68304"
        stroke="#9E8FA3"
        strokeWidth="1.5"
      />
      <path
        d="M3.43867 12.1124L16.0301 16.0211C16.3044 16.1062 16.5977 16.1713 16.8703 16.0809C19.8602 15.09 19.8602 3.67735 16.8703 2.68643C16.5977 2.59608 16.3044 2.66116 16.0301 2.74631L3.43867 6.65499C0.758543 7.48697 0.758543 11.2804 3.43867 12.1124Z"
        fill="#716377"
        stroke="#9E8FA3"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}

export function MomentsPlayboomActive() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99475 2.07141C8.68117 2.07141 7.39774 2.18029 6.1721 2.38165C5.82994 2.43786 5.56087 2.71911 5.52045 3.08198C5.34317 4.67383 5.25024 6.36107 5.25024 8.08223C5.25024 8.45765 5.25498 8.83027 5.26422 9.20015C5.3302 11.8425 7.44935 14.093 9.99474 14.093C12.5844 14.093 14.6499 11.8876 14.7238 9.19376C14.7339 8.82568 14.7393 8.45517 14.7393 8.08223C14.7393 6.37141 14.6383 4.6962 14.4658 3.10428C14.4256 2.73285 14.1483 2.4425 13.7945 2.38542C12.5613 2.18653 11.301 2.07141 9.99475 2.07141ZM5.92893 0.90149C7.23399 0.687084 8.59875 0.571411 9.99475 0.571411C11.3901 0.571411 12.7307 0.694453 14.0333 0.904563C14.7035 1.01266 15.2653 1.40389 15.6085 1.94507H17.2732C18.5987 1.94507 19.6732 3.01958 19.6732 4.34507V4.37591C19.6732 5.86869 19.1899 7.32351 18.297 8.41611C17.7142 9.12926 16.9816 9.65617 16.1674 9.9375C15.7914 12.7896 13.6343 15.1895 10.7446 15.5471V18.4286H13.4287C13.8429 18.4286 14.1787 18.7644 14.1787 19.1786C14.1787 19.5928 13.8429 19.9286 13.4287 19.9286H6.56054C6.14633 19.9286 5.81054 19.5928 5.81054 19.1786C5.81054 18.7644 6.14633 18.4286 6.56054 18.4286H9.24462V15.5453C6.38948 15.1792 4.19488 12.7548 3.81954 9.933C3.01056 9.65056 2.28267 9.12547 1.70296 8.41611C0.810057 7.32351 0.326721 5.86869 0.326721 4.37591V4.34507C0.326721 3.01958 1.40124 1.94507 2.72672 1.94507H4.36671C4.70446 1.40406 5.26124 1.01118 5.92893 0.90149ZM3.97408 3.44507H2.72672C2.22966 3.44507 1.82672 3.84801 1.82672 4.34507V4.37591C1.82672 5.55785 2.21171 6.66821 2.86444 7.46692C3.1315 7.79371 3.43181 8.05483 3.75054 8.24902C3.75034 8.19349 3.75024 8.13789 3.75024 8.08223C3.75024 6.49665 3.82671 4.9362 3.97408 3.44507ZM16.2393 8.08223C16.2393 6.49263 16.155 4.93521 16.0089 3.44507H17.2732C17.7703 3.44507 18.1732 3.84801 18.1732 4.34507V4.37591C18.1732 5.55785 17.7882 6.6682 17.1355 7.46692C16.8655 7.7973 16.5615 8.06056 16.2389 8.2554C16.2391 8.19774 16.2393 8.14002 16.2393 8.08223Z"
        fill="url(#paint0_linear_113_1174)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_113_1174"
          x1="1.28222"
          y1="3.17579"
          x2="18.6068"
          y2="21.8005"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.29" stopColor="#FFA267" />
          <stop offset="0.48" stopColor="#FF7154" />
        </linearGradient>
      </defs>
    </SvgIcon>
  )
}

export function Mahjong() {
  return (
    <SvgIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 20H20V0H0V20ZM2.188 5.29714C2.37594 5.1106 2.67818 4.99995 3.00006 4.99995H9.00006V2.85709C9.00006 2.46265 9.44783 2.14281 10.0001 2.14281C10.5523 2.14281 11.0001 2.46265 11.0001 2.85709V4.99995H17.0001C17.3215 5.00027 17.6228 5.1106 17.8108 5.29682C17.9983 5.48304 18.0496 5.7222 17.9483 5.94L15.9483 10.2257C15.8121 10.5172 15.4304 10.7139 15.0001 10.7142H11.0001V17.1428C11.0001 17.5373 10.5523 17.8571 10.0001 17.8571C9.44783 17.8571 9.00006 17.5373 9.00006 17.1428V10.7142H5.00006C4.5697 10.7139 4.188 10.5172 4.05184 10.2257L2.05184 5.94C1.9505 5.72252 2.00095 5.48336 2.188 5.29714Z"
        fill="#8842A7"
      />
      <path
        d="M8.99994 9.28571V6.42857H4.38794L5.72097 9.28571H8.99994Z"
        fill="#8842A7"
      />
      <path
        d="M15.6125 6.42857H11.0005V9.28571H14.2795L15.6125 6.42857Z"
        fill="#8842A7"
      />
    </SvgIcon>
  )
}

export function Star() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function SSL() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 36 40"
      fill="none"
    >
      <path
        d="M1.40943 10.0542C1.4278 9.59624 1.76623 9.21824 2.21538 9.12675C8.62187 7.82185 13.9417 5.22641 17.1979 1.89389C17.6335 1.44816 18.3665 1.44815 18.8021 1.89389C22.0583 5.22641 27.3781 7.82185 33.7846 9.12675C34.2338 9.21824 34.5722 9.59624 34.5906 10.0542C34.6087 10.5073 34.6179 10.9629 34.6179 11.421C34.6179 23.7923 27.9168 34.3902 18.403 38.8092C18.1474 38.9279 17.8526 38.9279 17.597 38.8092C8.08316 34.3902 1.38208 23.7923 1.38208 11.421C1.38208 10.9629 1.39125 10.5073 1.40943 10.0542Z"
        fill="#019F66"
        stroke="#019F66"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4564 25.1865C12.4564 24.4584 12.5999 23.7374 12.8783 23.0647C13.1572 22.392 13.5656 21.7808 14.0804 21.2659C14.5951 20.7511 15.2066 20.3427 15.8791 20.064C16.5517 19.7854 17.2726 19.642 18.0009 19.642C18.7291 19.642 19.45 19.7854 20.1226 20.064C20.7951 20.3427 21.4066 20.7511 21.9214 21.2659C22.4361 21.7808 22.8446 22.392 23.1234 23.0647C23.4019 23.7374 23.5453 24.4584 23.5453 25.1865C23.9828 25.1865 24.3374 25.5411 24.3374 25.9785V27.5627C24.3374 28.3948 24.1734 29.2188 23.8551 29.9876C23.5365 30.7564 23.07 31.4549 22.4814 32.0433C21.8931 32.6317 21.1947 33.0984 20.4258 33.4169C19.6569 33.7353 18.8332 33.8992 18.0009 33.8992C17.1686 33.8992 16.3448 33.7353 15.5759 33.4169C14.8071 33.0984 14.1086 32.6317 13.5203 32.0433C12.9317 31.4549 12.4653 30.7564 12.1466 29.9876C11.8283 29.2188 11.6643 28.3948 11.6643 27.5627V25.9785C11.6643 25.5411 12.019 25.1865 12.4564 25.1865ZM21.9612 25.1865C21.9612 24.6664 21.8587 24.1514 21.6599 23.6709L21.6305 23.6023C21.4325 23.1488 21.1513 22.7362 20.8013 22.3861C20.4335 22.0183 19.9969 21.7266 19.5165 21.5276C19.0358 21.3285 18.521 21.2261 18.0009 21.2261C17.4807 21.2261 16.9659 21.3285 16.4852 21.5276C16.0048 21.7266 15.5682 22.0183 15.2004 22.3861C14.8504 22.7362 14.5692 23.1488 14.3712 23.6023L14.3418 23.6709C14.143 24.1514 14.0405 24.6664 14.0405 25.1865H21.9612ZM18.5698 30.1678C18.9104 29.971 19.1396 29.6028 19.1396 29.1812C19.1396 28.5523 18.6298 28.0426 18.001 28.0426C17.3721 28.0426 16.8623 28.5523 16.8623 29.1812C16.8623 29.6024 17.0911 29.9703 17.4311 30.1672V30.8891C17.4311 31.2035 17.686 31.4584 18.0005 31.4584C18.3149 31.4584 18.5698 31.2035 18.5698 30.8891V30.1678Z"
        fill="white"
      />
      <path
        d="M12.5244 16.7724C11.9741 16.7724 11.4811 16.6829 11.0452 16.5041C10.6093 16.3252 10.2591 16.0605 9.99472 15.7099C9.93098 15.623 9.8747 15.5317 9.82587 15.4361C9.56963 14.9341 10.0531 14.4435 10.6168 14.4435H10.8159C11.2262 14.4435 11.5248 14.8105 11.8276 15.0874C11.992 15.2305 12.2064 15.302 12.4708 15.302C12.7423 15.302 12.9567 15.2412 13.1139 15.1196C13.2711 14.9908 13.3497 14.8155 13.3497 14.5937C13.3497 14.4077 13.2854 14.2539 13.1568 14.1322C13.0353 14.0106 12.8817 13.9104 12.6959 13.8317C12.5172 13.753 12.26 13.6636 11.9241 13.5634C11.4382 13.4132 11.0416 13.2629 10.7343 13.1127C10.427 12.9624 10.1626 12.7406 9.94113 12.4473C9.7196 12.1539 9.60884 11.7712 9.60884 11.2989C9.60884 10.5978 9.86252 10.0504 10.3699 9.65692C10.8772 9.25625 11.5382 9.05592 12.3529 9.05592C13.1818 9.05592 13.8499 9.25625 14.3573 9.65692C14.5926 9.83942 14.7772 10.0558 14.911 10.306C15.1793 10.8075 14.6951 11.3097 14.1264 11.3097H13.8369C13.473 11.3097 13.2013 10.9728 12.921 10.7409C12.7566 10.5978 12.5458 10.5262 12.2886 10.5262C12.067 10.5262 11.8884 10.587 11.7526 10.7087C11.6168 10.8231 11.549 10.9913 11.549 11.2131C11.549 11.4563 11.6633 11.6459 11.892 11.7819C12.1206 11.9178 12.4779 12.0645 12.9638 12.2219C13.4498 12.3865 13.8428 12.5439 14.1429 12.6941C14.4502 12.8444 14.7146 13.0626 14.9361 13.3488C15.1576 13.635 15.2684 14.0035 15.2684 14.4542C15.2684 14.8835 15.1576 15.2734 14.9361 15.624C14.7217 15.9746 14.4073 16.2536 13.9929 16.4611C13.5784 16.6686 13.0889 16.7724 12.5244 16.7724Z"
        fill="white"
      />
      <path
        d="M19.119 16.7724C18.5688 16.7724 18.0757 16.6829 17.6398 16.5041C17.2039 16.3252 16.8537 16.0605 16.5893 15.7099C16.5256 15.623 16.4693 15.5317 16.4205 15.4361C16.1642 14.9341 16.6478 14.4435 17.2114 14.4435H17.4105C17.8208 14.4435 18.1194 14.8105 18.4223 15.0874C18.5866 15.2305 18.801 15.302 19.0654 15.302C19.3369 15.302 19.5513 15.2412 19.7085 15.1196C19.8657 14.9908 19.9443 14.8155 19.9443 14.5937C19.9443 14.4077 19.88 14.2539 19.7514 14.1322C19.6299 14.0106 19.4763 13.9104 19.2905 13.8317C19.1118 13.753 18.8546 13.6636 18.5187 13.5634C18.0328 13.4132 17.6362 13.2629 17.3289 13.1127C17.0217 12.9624 16.7573 12.7406 16.5357 12.4473C16.3142 12.1539 16.2035 11.7712 16.2035 11.2989C16.2035 10.5978 16.4571 10.0504 16.9645 9.65692C17.4719 9.25625 18.1329 9.05592 18.9475 9.05592C19.7764 9.05592 20.4446 9.25625 20.9519 9.65692C21.1872 9.83942 21.3718 10.0558 21.5057 10.306C21.7739 10.8075 21.2897 11.3097 20.721 11.3097H20.4315C20.0677 11.3097 19.796 10.9728 19.5156 10.7409C19.3512 10.5978 19.1404 10.5262 18.8832 10.5262C18.6617 10.5262 18.483 10.587 18.3472 10.7087C18.2115 10.8231 18.1436 10.9913 18.1436 11.2131C18.1436 11.4563 18.2579 11.6459 18.4866 11.7819C18.7153 11.9178 19.0725 12.0645 19.5585 12.2219C20.0444 12.3865 20.4374 12.5439 20.7375 12.6941C21.0448 12.8444 21.3092 13.0626 21.5307 13.3488C21.7523 13.635 21.863 14.0035 21.863 14.4542C21.863 14.8835 21.7523 15.2734 21.5307 15.624C21.3164 15.9746 21.0019 16.2536 20.5875 16.4611C20.173 16.6686 19.6835 16.7724 19.119 16.7724Z"
        fill="white"
      />
      <path
        d="M24.8239 15.2806H26.5167C26.9078 15.2806 27.225 15.5977 27.225 15.9889C27.225 16.3801 26.9078 16.6972 26.5167 16.6972H23.991C23.4387 16.6972 22.991 16.2495 22.991 15.6972V10.0797C22.991 9.57355 23.4013 9.16324 23.9075 9.16324C24.4136 9.16324 24.8239 9.57355 24.8239 10.0797V15.2806Z"
        fill="white"
      />
    </SvgIcon>
  )
}

export function SmilingFace() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
    >
      <path
        d="M8.5 1C7.11553 1 5.76216 1.41054 4.61101 2.17971C3.45987 2.94888 2.56266 4.04213 2.03285 5.32122C1.50303 6.6003 1.36441 8.00776 1.63451 9.36563C1.9046 10.7235 2.57129 11.9708 3.55026 12.9497C4.52922 13.9287 5.7765 14.5954 7.13437 14.8655C8.49224 15.1356 9.8997 14.997 11.1788 14.4672C12.4579 13.9373 13.5511 13.0401 14.3203 11.889C15.0895 10.7378 15.5 9.38447 15.5 8C15.5 6.14348 14.7625 4.36301 13.4497 3.05025C12.137 1.7375 10.3565 1 8.5 1ZM8.5 14C7.31332 14 6.15328 13.6481 5.16658 12.9888C4.17989 12.3295 3.41085 11.3925 2.95673 10.2961C2.5026 9.19974 2.38378 7.99334 2.61529 6.82946C2.8468 5.66557 3.41825 4.59647 4.25736 3.75736C5.09648 2.91824 6.16558 2.3468 7.32946 2.11529C8.49335 1.88378 9.69975 2.0026 10.7961 2.45672C11.8925 2.91085 12.8295 3.67988 13.4888 4.66658C14.1481 5.65327 14.5 6.81331 14.5 8C14.5 9.5913 13.8679 11.1174 12.7426 12.2426C11.6174 13.3679 10.0913 14 8.5 14Z"
        fill="#00B67A"
      />
      <path
        d="M6.25 5.50004C6.00277 5.50004 5.7611 5.57335 5.55554 5.7107C5.34998 5.84806 5.18976 6.04328 5.09515 6.27169C5.00054 6.50009 4.97579 6.75143 5.02402 6.9939C5.07225 7.23638 5.1913 7.45911 5.36612 7.63392C5.54093 7.80874 5.76366 7.92779 6.00614 7.97602C6.24861 8.02425 6.49995 7.9995 6.72836 7.90489C6.95676 7.81028 7.15199 7.65006 7.28934 7.4445C7.42669 7.23894 7.5 6.99727 7.5 6.75004C7.50133 6.58552 7.46991 6.42237 7.40756 6.27011C7.34522 6.11786 7.25319 5.97953 7.13685 5.86319C7.02051 5.74685 6.88219 5.65482 6.72993 5.59248C6.57767 5.53013 6.41452 5.49871 6.25 5.50004ZM10.75 5.50004C10.5028 5.50004 10.2611 5.57335 10.0555 5.7107C9.84998 5.84806 9.68976 6.04328 9.59515 6.27169C9.50054 6.50009 9.47579 6.75143 9.52402 6.9939C9.57225 7.23638 9.6913 7.45911 9.86612 7.63392C10.0409 7.80874 10.2637 7.92779 10.5061 7.97602C10.7486 8.02425 10.9999 7.9995 11.2284 7.90489C11.4568 7.81028 11.652 7.65006 11.7893 7.4445C11.9267 7.23894 12 6.99727 12 6.75004C12.0013 6.58552 11.9699 6.42237 11.9076 6.27011C11.8452 6.11786 11.7532 5.97953 11.6369 5.86319C11.5205 5.74685 11.3822 5.65482 11.2299 5.59248C11.0777 5.53013 10.9145 5.49871 10.75 5.50004ZM8.5 12C9.19019 11.9989 9.86833 11.8191 10.4685 11.4783C11.0687 11.1375 11.5704 10.6472 11.925 10.055L11.07 9.55504C10.8032 9.99814 10.4263 10.3647 9.976 10.6192C9.5257 10.8737 9.01724 11.0074 8.5 11.0074C7.98276 11.0074 7.47431 10.8737 7.024 10.6192C6.57369 10.3647 6.19683 9.99814 5.93 9.55504L5.075 10.055C5.42958 10.6472 5.93135 11.1375 6.53151 11.4783C7.13168 11.8191 7.80982 11.9989 8.5 12Z"
        fill="#00B67A"
      />
    </SvgIcon>
  )
}

export function Lock_2() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
    >
      <path
        d="M12.5 7H11.5V4C11.5 3.20435 11.1839 2.44129 10.6213 1.87868C10.0587 1.31607 9.29565 1 8.5 1C7.70435 1 6.94129 1.31607 6.37868 1.87868C5.81607 2.44129 5.5 3.20435 5.5 4V7H4.5C4.23478 7 3.98043 7.10536 3.79289 7.29289C3.60536 7.48043 3.5 7.73478 3.5 8V14C3.5 14.2652 3.60536 14.5196 3.79289 14.7071C3.98043 14.8946 4.23478 15 4.5 15H12.5C12.7652 15 13.0196 14.8946 13.2071 14.7071C13.3946 14.5196 13.5 14.2652 13.5 14V8C13.5 7.73478 13.3946 7.48043 13.2071 7.29289C13.0196 7.10536 12.7652 7 12.5 7ZM6.5 4C6.5 3.46957 6.71071 2.96086 7.08579 2.58579C7.46086 2.21071 7.96957 2 8.5 2C9.03043 2 9.53914 2.21071 9.91421 2.58579C10.2893 2.96086 10.5 3.46957 10.5 4V7H6.5V4ZM12.5 14H4.5V8H12.5V14Z"
        fill="#00B67A"
      />
    </SvgIcon>
  )
}

export function SimpleLightning() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.30478 15.4601C6.20245 15.4169 6.11742 15.3408 6.0631 15.244C6.00878 15.1471 5.98826 15.0349 6.00478 14.9251L6.91478 9.00006H4.49978C4.42321 9.00212 4.3472 8.98656 4.2776 8.95459C4.20801 8.92261 4.14668 8.87508 4.09837 8.81565C4.05005 8.75622 4.01603 8.68649 3.99894 8.61183C3.98185 8.53717 3.98213 8.45959 3.99978 8.38506L5.49978 1.88506C5.52617 1.77319 5.5903 1.67384 5.68137 1.60371C5.77243 1.53359 5.88488 1.49698 5.99978 1.50006H10.9998C11.0745 1.4998 11.1483 1.51629 11.2158 1.5483C11.2833 1.58032 11.3427 1.62705 11.3898 1.68506C11.4375 1.74372 11.4713 1.81245 11.4886 1.88606C11.5059 1.95968 11.5063 2.03627 11.4898 2.11006L10.6248 6.00006H12.9998C13.0935 5.99987 13.1854 6.02602 13.2649 6.07553C13.3445 6.12503 13.4085 6.19591 13.4498 6.28006C13.4856 6.36083 13.4994 6.44965 13.4897 6.53748C13.4801 6.62531 13.4473 6.70901 13.3948 6.78006L6.89478 15.2801C6.85085 15.3452 6.79219 15.399 6.72356 15.4373C6.65494 15.4755 6.57827 15.497 6.49978 15.5001C6.43287 15.4988 6.36677 15.4852 6.30478 15.4601ZM9.37478 7.00006L10.3748 2.50006H6.39978L5.12978 8.00006H8.08478L7.28978 13.1401L11.9998 7.00006H9.37478Z"
        fill="#00B67A"
      />
    </SvgIcon>
  )
}

export const banknoteIcons = {
  default: BankNotePlayboomDefault,
  disabled: BankNotePlayboomDisabled,
  active: BankNotePlayboomActive,
}
export const casinoIcons = {
  default: ViewModulePlayboomDefault,
  disabled: ViewModulePlayboomDisabled,
  active: ViewModulePlayboomActive,
}
export const videocamIcons = {
  default: VideocamPlayboomDefault,
  disabled: VideocamPlayboomDisabled,
  active: VideocamPlayboomActive,
}
export const pragmaticIcons = {
  default: PragmaticPlayboomDefault,
  disabled: PragmaticPlayboomDisabled,
  active: PragmaticPlayboomActive,
}
export const momentsIcons = {
  default: MomentsPlayboomDefault,
  disabled: MomentsPlayboomDisabled,
  active: MomentsPlayboomActive,
}
export const faceIcons = {
  default: FacePlayboomDefault,
  disabled: FacePlayboomDisabled,
  active: FacePlayboomActive,
}
export const sportIcons = {
  default: BallPlayboomDefault,
  disabled: BallPlayboomDisabled,
  active: BallPlayboomActive,
}
export const promotionIcons = {
  default: NotificationsPlayboomDefault,
  disabled: NotificationsPlayboomDisabled,
  active: NotificationsPlayboomActive,
}

export function Payments() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 6C2 5.44772 2.44772 5 3 5H21C21.5523 5 22 5.44772 22 6V8.5H2V6Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 10.418H2V17.9999C2 18.5522 2.44772 18.9999 3 18.9999H21C21.5523 18.9999 22 18.5522 22 17.9999V10.418ZM4.92245 12.7237C4.48082 12.7237 4.1228 13.0817 4.1228 13.5233C4.1228 13.965 4.48082 14.323 4.92245 14.323H5.96573C6.40736 14.323 6.76538 13.965 6.76538 13.5233C6.76538 13.0817 6.40736 12.7237 5.96573 12.7237H4.92245Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

function PaymentsPlayBoomActive() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.66675 10.5C1.66675 7.92202 1.66675 6.63303 2.64306 5.83215C3.61937 5.03127 5.19071 4.66669 8.33341 4.66669H11.6667C14.8094 4.66669 16.3808 5.03127 17.3571 5.83215C18.3334 6.63303 18.3334 7.92202 18.3334 10.5C18.3334 13.078 18.3334 14.367 17.3571 15.1679C16.3808 15.9688 14.8094 16.3334 11.6667 16.3334H8.33341C5.19071 16.3334 3.61937 15.9688 2.64306 15.1679C1.66675 14.367 1.66675 13.078 1.66675 10.5Z"
        stroke="url(#paint0_linear_active)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.4375 13.625H5.3125"
        stroke="url(#paint1_linear_active)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5625 13.625H10.3906"
        stroke="url(#paint2_linear_active)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.1875 8.9375H17.8125"
        stroke="url(#paint3_linear_active)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_active"
          x1="2.48989"
          y1="6.23636"
          x2="12.0619"
          y2="20.945"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.29" stopColor="#FFA267" />
          <stop offset="0.48" stopColor="#FF7154" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_active"
          x1="5.46684"
          y1="13.7595"
          x2="5.95734"
          y2="15.4083"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.29" stopColor="#FFA267" />
          <stop offset="0.48" stopColor="#FF7154" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_active"
          x1="10.4485"
          y1="13.7595"
          x2="11.3223"
          y2="14.861"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.29" stopColor="#FFA267" />
          <stop offset="0.48" stopColor="#FF7154" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_active"
          x1="2.9592"
          y1="9.07204"
          x2="3.06561"
          y2="10.8604"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.29" stopColor="#FFA267" />
          <stop offset="0.48" stopColor="#FF7154" />
        </linearGradient>
      </defs>
    </SvgIcon>
  )
}

function PaymentsPlayBoomDefault() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.66675 10.5C1.66675 7.92202 1.66675 6.63303 2.64306 5.83215C3.61937 5.03127 5.19071 4.66669 8.33341 4.66669H11.6667C14.8094 4.66669 16.3808 5.03127 17.3571 5.83215C18.3334 6.63303 18.3334 7.92202 18.3334 10.5C18.3334 13.078 18.3334 14.367 17.3571 15.1679C16.3808 15.9688 14.8094 16.3334 11.6667 16.3334H8.33341C5.19071 16.3334 3.61937 15.9688 2.64306 15.1679C1.66675 14.367 1.66675 13.078 1.66675 10.5Z"
        stroke="url(#paint0_linear_default)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.4375 13.625H5.3125"
        stroke="url(#paint1_linear_default)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5625 13.625H10.3906"
        stroke="url(#paint2_linear_default)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.1875 8.9375H17.8125"
        stroke="url(#paint3_linear_default)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_default"
          x1="2.48989"
          y1="6.23636"
          x2="12.0619"
          y2="20.945"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.38" stopColor="#fff" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_default"
          x1="5.46684"
          y1="13.7595"
          x2="5.95734"
          y2="15.4083"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.38" stopColor="#fff" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_default"
          x1="10.4485"
          y1="13.7595"
          x2="11.3223"
          y2="14.861"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.38" stopColor="#fff" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_default"
          x1="2.9592"
          y1="9.07204"
          x2="3.06561"
          y2="10.8604"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.38" stopColor="#fff" />
        </linearGradient>
      </defs>
    </SvgIcon>
  )
}

export const PaymentsIcons = {
  default: PaymentsPlayBoomDefault,
  active: PaymentsPlayBoomActive,
  disabled: PaymentsPlayBoomDefault,
}
